/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-06-06 16:24:27
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-20 16:07:44
 * @FilePath: \baishu_react_ui\src\components\BsyFormData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { createRef } from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyIconBtn from "../BsyIconBtn";
import "./index.css";

import { BsyConfig } from "../../global/BsyConfig";
import get from "lodash/get";
import map from "lodash/map";
import _ from "lodash";
import { BsyWidget } from "../BsyWidget";

import BsyNavigator from "../BsyNavigator";
import BsySLoading from "../BsySLoading";
import ShowRulesProcessor from "../../utils/ShowRulesProcessor";
import BsyFormMultiTab from "../BsyFormMultiTab";
import BsyFileUpload from "../BsyFileUpload";
import BsySignature from "../BsySignature";
import BsyLinkData from "../BsyLinkData";
import BsyLinkQuery from "../BsyLinkQuery";
import BsyFlowComment from "../BsyFlowComment";
import BsyDialog from "../BsyDialog";
import BsyShareUrlPane from "../BsyShareUrlPane";
import BsySwitchBtn from "../BsySwitchBtn";
import BsySelectCheckBox, { TriggerComboCheckPane } from "../BsySelectCheckBox";
import BsyMsgBubble from "../BsyMsgBubble";
import BsyAlert from "../BsyAlert";
import BsySlidePane from "../BsySlidePane";
import BsyMaskLayer from "../BsyMaskLayer";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyFormLogPane from "../BsyFormLogPane";

import BsySubform from "../BsySubform";
import BsyFormPane from "../BsyFormPane";
import BsyTextEditor from "../BsyTextEditor";
import BsyNumber from "../BsyNumber";
import BsySeparator from "../BsySeparator";
import rowExecuteRely_3_0 from "../../utils/rowExecuteRely_3_0";
import BsyTextArea from "../BsyTextArea";
import BsyTagList from "../BsyTagList";
import BsySystemPrint from "../BsySystemPrint";
import { dayjsUtils } from "../../utils/dayjsUtils";

class BsyFormData extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-form-data",
      dataUrl: "/data/dataView",
      title: "",
      width: "80%",
      header: null,
      hasHeader: !0,
      layout: null,
      data: null,
      flow: null,
      comments: null,
      isPrint: !1,
      hasFlowBtn: !1,
      hasShareBtn: !0,
      hasPrintBtn: !1,
      hasEditBtn: !1,
      hasCopy: !1,
      hasDeleteBtn: !1,
      hasLogView: !1, //流程日志
      isreport: !1,
      url: null,
      hasLog: !1,
      hasComment: !1,
      hasDataCommentBtn: !0,
      hasRecoverBtn: !1,
      hasShowFieldsBtn: !0,
      hasSwitchBtn: !1,
      hasAddBtn: !1,
      hasQrcode: !1,
      entrance: "form",
      needFetchViewData: !1,
      hasDataViewLink: !1,
      ptlist: [],
      dataIndex: 1,
      enableRowEdit: false,
      dataCount: 10,
      onEditData: null,
      onDeleteData: null,
      onRecoverData: null,
      onSwitchData: null,
      onCloseFlow: null,
      onClose: null,
      showFields: [],
      allShowFields: [],
      allFields: null,
      onFlowNodeClick: null,
      height: null,
      subItemWidth: 146,
      ignoreVisible: false,
      hasCustomPrint: !1,
      authGroupId: null,
      popupFormPath: [],
      optAuth: null,
      hasMultiTab: !1,
      onShowFieldsChange: null,
      hAdjust: 15,
      tabItems: [],
      showForms: [],
      rawdata: false,
      widgetId: null, //报表控件id
      refAppId: null, //如果是跨应用 源数据表的应用id
      mode: "", //'print' 提交数据后弹出的打印页面
      ...props,
    });
    this.state = {
      loading: false,
      showtip: "",
      comments: [],
    };
    this.multiTab = React.createRef();

    this.status = this.getSideStatus();
    this.isFull =
      props.showForms.length > 1 ? props.isFull : this.getfullscreenStatus();
    this.linkquerys = [];
    this.subformRenderKey = 0;
    this.showFields = [];
    this.btns = [];
    this.moreBtns = [];
    this.btnCount = 0;
  }

  _switchData = (index) => {
    let that = this;
    const { dataIndex, dataCount } = this.options;
    if (that.switchinterval) {
      clearTimeout(that.switchinterval);
      that.switchinterval = null;
    }
    if (dataIndex < 1 || index <= 0) {
      return;
    }

    if (dataIndex > dataCount) {
      return;
    }

    this.setState(
      {
        showtip: index > dataIndex ? "next" : "prev",
      },
      () => {
        that.switchinterval = setTimeout(function () {
          that.props.onSwitchData && that.props.onSwitchData(index);
        }, 500);
      }
    );
  };

  getViewVisibleMap = () => {
    let b = this;

    if (b.options.ignoreAuth) {
      return;
    }

    if (b.options.entrance !== "form") {
      return;
    }

    // // 报表打开的，会带 widgetId
    // if(b.options.widgetId && b.options.widgetId.indexOf("_widget") > -1) {
    //   return;
    // }

    // if(!b.options.needFetchViewData) {
    //   return;
    // }

    if (!this.showRulesProcessor) {
      this.tabMap = {};
      this.showRules = {};
      this.subVisbleMaps = {};
      this.subColumnVisibleMaps = {};

      this.multiTabs = this.options.multiTabs;
      var items = this.options.form?.items || [];
      var tabsItem = []; //临时构建标签页到items中
      BsyUtils.forEach(this.multiTabs, function (tabindex, tabdata) {
        tabsItem.push({
          label: React.language("multi.tab.name") + "." + tabdata.title,
          widget: {
            widgetName: tabdata.name,
            type: "tabs",
          },
        });
      });
      this.showRulesProcessor = new ShowRulesProcessor({
        fieldShowRules: this.options.fieldShowRules,
        fields: [...items, ...tabsItem],
      });
    }

    let value = this._getLinkValueMap(this.options.data, items);

    this.showRules = {};
    this.subVisbleMaps = {};
    this.subColumnVisibleMaps = {};

    this.showRules = this.showRulesProcessor.getViewVisibleMap(
      value,
      function (t) {
        return false;
      }
    );
    BsyUtils.forEach(this.showRules, (key, val) => {
      if (key.indexOf("tab_") > -1) {
        if (!val) {
          BsyUtils.forEach(b.tabMap[key], (tabkey, tabval) => {
            this.showRules[tabval] = false;
          });
        }
      }
    });

    BsyUtils.forEach(items, function (t, i) {
      let a, n, e, s, o;

      if (i.widget && "subform" === i.widget.type) {
        a = i.widget.widgetName;
        e = _.get(b.options.subformFieldShowRules, a);

        if (!BsyUtils.isObjectEmpty(e)) {
          n = new ShowRulesProcessor({
            fieldShowRules: e,
            fields: i.widget.items,
          }); //(e, i.widget.items);
          e = value[a];
          s = {};
          BsyUtils.forEach(e, function (t, e) {
            e = b._getLinkValueMap(e, i.widget.items);
            s[t] = n.getViewVisibleMap(e, function (t) {
              return false;
            });
          });
          b.subVisbleMaps[a] = s;
          o = {};
          BsyUtils.forEach(s, function (t, e) {
            BsyUtils.forEach(e, function (t, e) {
              BsyUtils.isNull(o[t])
                ? (o[t] = !1 === e)
                : (o[t] = o[t] && !1 === e);
            });
          });
          b.subColumnVisibleMaps[a] = o;
        }
      }
    });
    // console.log('formData getViewVisibleMap showRules', this.showRules)
    // console.log('formData getViewVisibleMap subVisbleMaps', this.subVisbleMaps)
    // console.log('formData getViewVisibleMap subColumnVisibleMaps', this.subColumnVisibleMaps)
  };

  componentDidMount() {
    super.componentDidMount();
    const { flow } = this.options;
    if (flow) {
      let wrapperWidth = 0; // this.element.current.querySelector('.btn-pane').offsetWidth;
      if (this.element.current.querySelector(".bsy-footer")) {
        wrapperWidth =
          this.element.current.querySelector(".bsy-footer").offsetWidth;
      }
      if (flow.print) {
        let btn = {
          text: React.language("print"),
          type: "blue",
          handler: "print",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.forward) {
        let btn = {
          text: flow.forward.text,
          type: "blue",
          handler: "forward",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.save) {
        let btn = {
          text: flow.save.text,
          type: "blue",
          handler: "save",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.urge) {
        let btn = {
          text: flow.urge.text,
          type: "blue",
          handler: "urge",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.back) {
        let btn = {
          text: flow.back.text,
          type: "white",
          handler: "back",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.sign) {
        let btn = {
          text: flow.sign.text,
          type: "white",
          handler: "sign",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.transfer) {
        let btn = {
          text: flow.transfer.text,
          type: "white",
          handler: "transfer",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.revoke) {
        let btn = {
          text: flow.revoke.text,
          type: "white",
          handler: "revoke",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.close) {
        let btn = {
          text: flow.close.text,
          type: "white",
          handler: "close",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.cancel) {
        let btn = {
          text: flow.cancel.text,
          type: "white",
          handler: "cancel",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
    }
    if (this.status == "false") {
      this.element.current.classList.remove("side");
    } else {
      this.element.current.classList.add("side");
    }

    let i1 = this.element.current.querySelector(".all i");
    let parent = BsyUtils.closestClass(this.element.current, "bsy-form-pane");
    let parent1 = BsyUtils.closestClass(
      this.element.current,
      "bsy-form-edit-pane"
    );

    i1.className = "";
    if (this.isFull == "true") {
      if (parent) {
        parent.style.width = "100%";
      }
      if (parent1) {
        parent1.style.width = "100%";
      }

      i1.classList.add("icon-bby-collapse");
    } else {
      if (parent) parent.style.width = "80%";
      if (parent1) {
        if (parent) parent.style.width = "100%";
        parent1.style.width = "80%";
      }
      i1.classList.add("icon-bby-expansion");
    }

    this.readData();
    this.bindKey();
  }

  bindKey = () => {
    let that = this;
    const { appId, formId, entryId, hasSwitchBtn } = this.options;
    if (!hasSwitchBtn) {
      return;
    }
    let k = [appId, formId || entryId].join(".");
    window.$(document).unbind(`keydown.${k}`);
    window.$(document).bind(`keydown.${k}`, function (event) {
      const { dataIndex, dataCount } = that.options;
      if (event.keyCode == BsyConfig().Keys.LEFT) {
        that._switchData(dataIndex - 1);
        return;
      }
      if (event.keyCode == BsyConfig().Keys.RIGHT) {
        that._switchData(dataIndex + 1);
        return;
      }
      if (event.ctrlKey && event.keyCode == BsyConfig().Keys.LEFT) {
        that._switchData(0);
        return;
      }
      if (event.ctrlKey && event.keyCode == BsyConfig().Keys.RIGHT) {
        that._switchData(dataCount - 1);
        return;
      }
    });
  };

  unbindKey = () => {
    const { appId, formId, entryId, hasSwitchBtn } = this.options;
    if (!hasSwitchBtn) {
      return;
    }
    let k = [appId, formId || entryId].join(".");
    window.$(document).unbind(`keydown.${k}`);
  };

  getShowFieldKey = () => {
    var e = this.options;
    var data = this.options.data;
    return BsyUtils.Store.getKey("formDataShowFields", {
      appId: data.appId,
      entryId: data.formId || data.entryId,
      groupId: e.authGroupId || "",
      widgetId: e.widgetId || "",
    });
  };

  getShowFields = () => {
    return BsyUtils.Store.get(this.getShowFieldKey());
  };

  updateShowFields = (val) => {
    return BsyUtils.Store.set(this.getShowFieldKey(), val);
  };

  _createDataFilter = (a, b, c, s, _const) => {
    var d = {};
    var type = a.type;
    switch (type) {
      case "datetime": {
        var format = (a && a.format) || a.format;
        d[c] = {
          widgetType: "datelimit",
          orgWidgetType: type,
        };
        // if(a.options)

        var e = {},
          f = new Date(b);
        var g = new Date(b);
        //根据 年 年月模式 需要特殊处理时间的过滤范围 20190402 bobo
        switch (format) {
          case "yyyy-MM": {
            var m = f.getMonth();
            f.setDate(1);
            f.setHours(0, 0, 0, 0);
            e.min = f.getTime();
            g.setMonth(m + 1, 1);
            g.setHours(0, 0, 0, 0);
            e.max = g.getTime() - 1;
            break;
          }
          case "yyyy": {
            var y = f.getFullYear();
            f.setFullYear(y, 0, 1);
            f.setHours(0, 0, 0, 0);
            e.min = f.getTime();
            g.setFullYear(y + 1, 0, 1);
            g.setHours(0, 0, 0, 0);
            e.max = g.getTime() - 1;
            break;
          }
          default: {
            f.setHours(0, 0, 0, 0);
            e.min = f.getTime();
            g.setHours(23, 59, 59, 999);
            e.max = g.getTime();
            break;
          }
        }
        d[c] = {
          widgetType: "datelimit",
          orgWidgetType: type,
          widgetValue: e,
        };
        break;
      }

      case "text":
      case "radiogroup":
      case "combo":
      case "textarea": {
        var h = b;
        BsyUtils.isArray(b) || (h = [b]);
        d[c] = {
          widgetType: "text",
          orgWidgetType: type,
          widgetValue: h,
        };
        break;
      }

      // case "user":
      case "usergroup":
      // case "dept":
      case "deptgroup":
      case "combocheck":
      case "checkboxgroup": {
        var h = b;
        BsyUtils.isArray(b) || (h = [b]);
        d[c] = {
          widgetType: "check",
          orgWidgetType: type,
          widgetValue: h,
        };
        break;
      }

      case "dept": {
        var h = b;
        BsyUtils.isArray(b) || (h = [b]);
        d[c] = {
          widgetType: "dept",
          orgWidgetType: type,
          widgetValue: h,
        };
        break;
      }
      case "user": {
        var h = b;
        BsyUtils.isArray(b) || (h = [b]);
        d[c] = {
          widgetType: "user",
          orgWidgetType: type,
          widgetValue: h,
        };
        break;
      }

      case "address": {
        var h = b;
        BsyUtils.isArray(b) || (h = [b]);
        d[c] = {
          widgetType: "address",
          orgWidgetType: type,
          widgetValue: h,
        };
        break;
      }

      default: {
        var h = b;
        BsyUtils.isArray(b) || (h = [b]);
        d[c] = {
          widgetType: "combocheck",
          orgWidgetType: type,
          widgetValue: h,
        };
      }
    }
    if (s) d[c].method = s;
    if (_const) d[c].const = _const;

    return d;
  };

  _getLinkQueryData = (b) => {
    let c = this;
    let opt = b.options || b;
    let data = this.options.data;
    if ("linkquery" === opt.type) {
      let d = opt.widgetName,
        e = null;
      if (opt.subform) {
        e = opt.rowIdx;
      }

      if (!c.fieldMap) {
        c.fieldMap = {};
        BsyUtils.forEach(this.options.items || [], function (a1, b1) {
          c.fieldMap[b1.widget.widgetName] = {
            text: b1.label,
            type: b1.widget.type,
            name: b1.widget.widgetName,
            items: b1.widget.items,
          };
        });
      }

      // this.formManager.rowRely.rely.setStateMap(d, this.formManager.rowRely.rely.RELY_END);
      // this.formManager.rowRely.rely.setAsyncMap(d, this.formManager.rowRely.rely.RELY_END);

      // } else {
      //     this.rely.setStateMap(d, this.rely.RELY_END),
      //     this.rely.setAsyncMap(d, this.rely.RELY_END);
      // }

      let f = {},
        g = [],
        h = opt.linkForm,
        refAppid = opt.refAppid || opt.refAppId;
      if (h) {
        let i = !0;
        if (BsyUtils.isArray(opt.linkFilter)) {
          //老的模式
          BsyUtils.forEach(opt.linkFilter, function (a, b1) {
            // let d = c.getWidgetByName(b.rely, e);

            let d = c.fieldMap[b1.rely];

            if (d) {
              let f = data[b1.rely];
              return BsyUtils.isObjectEmpty(f)
                ? ((i = !1), !1)
                : void g.push(c._createDataFilter(d, f, b1.link));
            }
          });
          if (i) {
            if (!BsyUtils.isObjectEmpty(g)) {
              f[h] = g;
              b.reload(f);
            }
          }
        } else {
          if (
            !BsyUtils.isObjectEmpty(opt.linkFilter) &&
            !BsyUtils.isObjectEmpty(opt.linkFilter.cond)
          ) {
            let go = true;
            let dd = [];
            let linkFilter = JSON.parse(JSON.stringify(opt.linkFilter));
            BsyUtils.forEach(linkFilter.cond, function (a, b1) {
              b1.form =
                !refAppid || window.FX.STATIC.APPID === refAppid
                  ? h
                  : [h, refAppid].join("@");

              if (b1.valueMode === "depend") {
                let tt = [];
                BsyUtils.forEach(b1.value, function (k, name) {
                  let d = c.fieldMap[name];
                  if (name.indexOf(".") > -1 && e != null) {
                    d = c.fieldMap[opt.subform].items[e];
                  }
                  if (d) {
                    let f = data[name];
                    if (name.indexOf(".") > -1 && e != null) {
                      let df = name.split(".");
                      if (data[df[0]] && data[df[0]][e])
                        f = data[df[0]][e][df[1]];
                    }
                    if (f) {
                      switch (d.type) {
                        case "datetime": {
                          // let format = (d && d && d.format) || 'yyyy-MM-dd'

                          // let dc = new Date(f);

                          // if (dc != 'Invalid Date') {
                          //     f = BsyUtils.date2Str(dc, format)
                          // } else {
                          //     f = null;
                          // }
                          tt.push(f);
                          break;
                        }
                        case "user":
                        case "dept": {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            tt = tt.concat(f.id || f._id);
                          }
                          break;
                        }
                        case "linkdata": {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            tt.push(f.key);
                          }
                          break;
                        }
                        case "usergroup":
                        case "deptgroup": {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            if (BsyUtils.isArray(f)) {
                              BsyUtils.forEach(f, (k, v) => {
                                let id = v.id || v._id || v;
                                if (id) tt.push(id);
                              });
                            }
                          }
                          break;
                        }
                        default: {
                          if (BsyUtils.isArray(f)) {
                            tt = tt.concat(f);
                          } else {
                            tt.push(f);
                          }
                        }
                      }
                    } else {
                      if (linkFilter.rel != "or") {
                        i = !1;
                      }
                      // TODO 修复时间范围只选一个是也会联动
                      if (tt.length) {
                        i = true;
                      }
                      return !1;
                    }
                  }
                });
                b1.value = tt;
              } else if (b1.valueMode === "custom") {
                b1.value = (b1.value || []).map((item) => {
                  // if (item === "100000000000000000000002") {
                  //   return window.FX.STATIC?.user?._id;
                  // }
                  return item;
                });
              }

              if (b1.method !== "not_empty" && b1.method !== "empty") {
                if (BsyUtils.isObjectEmpty(b1.value)) {
                  if (linkFilter.rel !== "or") {
                    go = false;
                  }
                }
              }

              // if(!BsyUtils.isObjectEmpty(b.value))
              // {
              //     dd.push(1);
              // }
            });
            if (i) {
              if (go) {
                b.field ? b.field.reload(linkFilter) : b.reload(linkFilter);
              }
              // if(!BsyUtils.isObjectEmpty(dd))
              // {
              //     b.reload(linkFilter)
              // }
            }
          }
        }
      }
    }
  };

  _getLinkValueMap = (t, e) => {
    let a = {};
    BsyUtils.forEach(e, function (t, e) {
      let i = get(e, "widget.widgetName");
      i && (a[i] = get(e, "widget.type"));
    });
    let n = {};
    BsyUtils.forEach(t, function (t, e) {
      switch (a[t]) {
        case "user":
        case "dept":
          n[t] = get(e, "_id", null) || get(e, "id", null);
          break;
        case "usergroup":
        case "deptgroup":
          n[t] = map(e, function (t) {
            return t._id || t.id;
          });
          break;
        case "datetime":
          let i = BsyUtils.parseDate(e);
          n[t] = i ? i.getTime() : null;
          break;
        default:
          n[t] = e;
      }
    });
    return n;
  };

  getHeader = () => {
    var b = this.options;
    var ss = [];
    BsyUtils.forEach(b.items, function (a1, b1) {
      if (b1.widget.type == "subform") {
        var obje = Object.assign({}, b1);
        BsyUtils.forEach(obje.items, function (a2, b2) {
          var ssd = [b1.widget.widgetName, b2.widget.widgetName].join(".");
          if (b.optAuth && b.optAuth.hasOwnProperty(ssd)) {
            obje.items[a2] = Object.assign({}, obje, {
              visible: b.optAuth[ssd].visible,
            });
          } else {
            obje.items[a2] = obje;
          }
        });

        if (b.optAuth && b.optAuth.hasOwnProperty(b1.widget.widgetName)) {
          ss.push(
            Object.assign({}, obje, {
              visible: b.optAuth[b1.widget.widgetName].visible,
            })
          );
        } else {
          ss.push(obje);
        }
      } else {
        if (b.optAuth && b.optAuth.hasOwnProperty(b1.widget.widgetName)) {
          ss.push(
            Object.assign({}, b1, {
              visible: b.optAuth[b1.widget.widgetName].visible,
            })
          );
        } else {
          ss.push(Object.assign({}, b1));
        }
      }
    });
    return ss;
  };

  // {
  //     // TODO 修复有时候options.items 不存在  从form中获取
  //     const { form, optAuth, ignoreVisible, multiTabs, header } = this.options;
  //     const { items = [] } = form || {}
  //     if (ignoreVisible && BsyUtils.isObjectEmpty(optAuth)) {
  //         var s1 = [];
  //         BsyUtils.forEach(header, (index, val) => {
  //             let df = items.filter(e => {
  //                 return e.widget.widgetName == val.name;
  //             })
  //             if (df.length > 0) {
  //                 s1 = s1.concat(df);
  //             }
  //         })
  //         return s1;
  //     }

  //     var ss = [];
  //     BsyUtils.forEach(items, function (a1, b1) {
  //         if (b1.widget.type == 'subform') {
  //             var obje = { ...{}, ...b1 }
  //             BsyUtils.forEach(obje.items, function (a2, b2) {
  //                 var ssd = [b1.widget.widgetName, b2.widget.widgetName].join(".");
  //                 if (optAuth && optAuth.hasOwnProperty(ssd)) {
  //                     obje.items[a2] = {
  //                         ...{}, ...obje, visible: optAuth[ssd].visible
  //                     }
  //                 } else {
  //                     obje.items[a2] = obje
  //                 }
  //             })

  //             if (optAuth && optAuth.hasOwnProperty(b1.widget.widgetName)) {
  //                 ss.push({ ...{}, ...obje, visible: optAuth[b1.widget.widgetName].visible })
  //             } else {
  //                 ss.push(obje)
  //             }
  //         } else {
  //             if (b1.widget.type == 'button') {
  //                 //按钮要强制FALSE
  //                 b1.widget.visible = false;
  //                 if (optAuth && optAuth.hasOwnProperty(b1.widget.widgetName)) {
  //                     optAuth[b1.widget.widgetName].visible = false;
  //                 }
  //             } else {
  //                 if (optAuth && optAuth.hasOwnProperty(b1.widget.widgetName)) {
  //                     ss.push({ ...{}, ...b1, visible: optAuth[b1.widget.widgetName].visible })
  //                 } else {
  //                     ss.push({ ...b1 })
  //                 }
  //             }

  //         }
  //     })
  //     BsyUtils.forEach(multiTabs, (tabindex, tabdata) => {
  //         ss.push({
  //             label: React.language('multi.tab.name') + '.' + tabdata.title,
  //             widget: {
  //                 widgetName: tabdata.name,
  //                 type: 'tabs'
  //             }
  //         })
  //     })
  //     return ss;
  // }

  _isSystemField = (t) => {
    return (
      -1 < window.FX.LimitFields.systemFields.indexOf(t.name) &&
      t.name !== "label"
    );
  };

  _getTabItems = (n) => {
    var rd = this;
    let dfe = Object.assign([], n); //JSON.parse(JSON.stringify(n));
    var r = [];
    BsyUtils.forEach(dfe, (key, val) => {
      if (val && val.tab) {
        if (
          rd.showRules &&
          (rd.showRules[val.name] === false || rd.showRules[val.tab] === false)
        ) {
          val.hidden = true;
        }

        r.push(val);
      }
    });
    return r;
  };

  //计算界面绘制需要的数据
  calculate = () => {
    let { ignoreVisible, items, header, needFetchViewData } = this.options;
    var n = header || items;
    let that = this;
    this.allFields = [];
    if (!needFetchViewData) {
      if (header && header.length && header[0].hasOwnProperty("widget")) {
        var headert = [];
        header.map((item) => {
          let dnitem = this.widget2Item(item);

          if (!item || item.type == "dataload" || item.type == "button") {
            return;
          }
          if (!!item.widget.visible) {
            headert.push(dnitem);
          }
        });
        this.allFields = headert;
      } else {
        this.allFields = header;
      }
    } else {
      n.map((item) => {
        item = this.widget2Item(item);

        if (!item || item.type == "dataload" || item.type == "button") {
          return;
        }
        if (item.type == "subform") {
          let df1 = [];
          if (items) {
            let subitems = item.items;
            items.map((e) => {
              if (
                e.widget.type == "subform" &&
                e.widget.widgetName == item.name
              ) {
                let xxitem = e.widget.items;
                subitems &&
                  subitems.map((se) => {
                    xxitem &&
                      xxitem.map((xxe) => {
                        if (
                          xxe.widget.type == "button" &&
                          xxe.widget.widgetName == se.name
                        ) {
                          se.btnText = xxe.widget.text;
                          se.eventAlert = xxe.widget.eventAlert;
                          se.alertinfo = xxe.widget.alertinfo;
                          se.background = xxe.widget.background;
                        }
                      });
                    df1.push(se);
                  });
              }
            });
            item.items = subitems;
          }
        } else {
        }
        that.allFields.push(item);
      });
    }

    if (!ignoreVisible) {
      this.getViewVisibleMap();
    }

    this.concatMap = {};
    this.header = [];

    var t = BsyUtils.Store.get(this.getShowFieldKey());
    if (t) {
      console.log("getShowFieldsByNames = 11111 ");
      this.options.showFields = BsyUtils.getShowFieldsByNames(n, t);
      console.log("getShowFieldsByNames = 22222 ");
    } else {
      this.options.showFields = this.allFields;
    }

    this.linewidth = {};
    this.lineStyleList = {};
    this.labelHidden = {};
    that.subformLineWidth = {};
    BsyUtils.forEach(items, function (key, res) {
      that.linewidth[res.widget.widgetName] = res.lineWidth;
      that.lineStyleList[res.widget.widgetName] = res.widget.lineStyle;
      that.labelHidden[res.widget.widgetName] = res.widget.labelHidden;
      if (res.widget.type === "subform") {
        BsyUtils.forEach(res.widget.items, function (key1, res1) {
          var customWidth;
          switch (res1.fieldWidth) {
            case window.FX.CONST.FIELD_WIDTH.FIVE:
              customWidth = 30;
              break;
            case window.FX.CONST.FIELD_WIDTH.FOUR:
              customWidth = 40;
              break;
            case window.FX.CONST.FIELD_WIDTH.THIRD:
              customWidth = 60;
              break;
            case window.FX.CONST.FIELD_WIDTH.HALF:
              customWidth = 80;
              break;
            case window.FX.CONST.FIELD_WIDTH.TWICE:
              customWidth = 300;
              break;
            default:
              customWidth = BsyUtils.getSubformWidgetWidth(res1);
              break;
          }
          that.subformLineWidth[
            res.widget.widgetName + "." + res1.widget.widgetName
          ] = res1.widget.customWidth || res1.widget.customWith || customWidth;
          that.labelHidden[
            res.widget.widgetName + "." + res1.widget.widgetName
          ] = res1.widget.labelHidden;
        });
      }
    });

    this.options.tabItems = this._getTabItems(this.options.showFields);
    this.options.hasMultiTab = BsyUtils.isObjectEmpty(this.options.tabItems)
      ? false
      : true;

    that.hidecols = {};
    BsyUtils.forEach(items, function (key, res) {
      if (res.widget.type === "subform") {
        let subform = res.widget.widgetName;

        that.hidecols[subform] = {};
        //显示为空
        if (that.subVisbleMaps && that.subVisbleMaps[subform]) {
          BsyUtils.forEach(
            that.subVisbleMaps[subform],
            function (subindex, subdata) {
              BsyUtils.forEach(subdata, function (rowkey, rowdata) {
                if (!that.hidecols[subform].hasOwnProperty(rowkey)) {
                  that.hidecols[subform][rowkey] = false;
                }
                if (rowdata == false) {
                  that.options.data[subform][subindex][rowkey] = "";
                } else {
                  that.hidecols[subform][rowkey] = true;
                }
              });
            }
          );
        }
      }
    });
  };

  _setLinkQuery = (tab) => {
    let a = this;
    setTimeout(() => {
      BsyUtils.forEach(a.linkquerys, function (b, c) {
        if (tab) {
          if (c.options && c.options.tab && c.options.tab === tab) {
            a._getLinkQueryData(c);
          }
        } else {
          a._getLinkQueryData(c);
        }
      });
    }, 200);
  };

  createFlowComments = () => {
    // 解决bug 3042 屏蔽数据界面的审批意见

    let that = this;
    var a = this.options;
    if (window.FX.STATIC.TOKEN || (!a.hasFlowBtn && !a.hasFlow)) {
      return;
    }

    if (!a.hasFlowLog && !a.ignoreOptAuth) {
      return "";
    }
    React.axios("/data/log_flow", {
      appId: a.appId,
      refAppId: a.refAppId,
      entryId: a.entryId,
      formId: a.formId || a.entryId,
      dataId: a.data._id,
      authGroupId: a.authGroupId,
      popupFormPath:
        a.dataUrl === "/data/dash_process_data" ? null : a.popupFormPath,
      flowType: a.flowType ? a.flowType : a.flow ? a.flow.flowType : undefined,
      flowId: a.flowId ? a.flowId : a.flow ? a.flow.flowId : undefined,
      extDashData: that.extDashData(),
    }).then((res) => {
      BsyUtils.showAjaxTip(
        res.data,
        () => {
          this.setState({
            logs: res.data.logs,
            comments: res.data.logs,
          });
        },
        () => { }
      );
    });
  };

  extDashData = () => {
    var b = this,
      c = this.options;
    return c.widgetId && !c.rawdata ? c.extDashData : undefined;
  };

  showTabs = () => {
    const { multiTabs, tabItems } = this.options;
    // this.showRules
    let tabs = BsyUtils.getNoEmptyTabs(tabItems, multiTabs);

    BsyUtils.forEach(this.showRules, (a1, tab) => {
      if (a1.indexOf("tab") > -1) {
        if (tab === false) {
          var index = -1;
          var n = tabs.filter((e, i) => {
            if (e.name === a1) {
              index = i;
            }
            return e.name === a1;
          });
          if (n.length) {
            tabs.splice(index, 1);
          }
        }
      }
    });
    if (tabs.length > 0) {
      if (this.multiTab && this.multiTab.current) {
        this.multiTab.current.setActiveTabName(tabs[0].name);
      }
    }
  };

  readData = () => {
    let that = this;
    var e = this.options;
    if (!e.needFetchViewData) {
      this.calculate();
      this.setState({}, () => {
        this.showTabs();
        this._setLinkQuery();
        this.createFlowComments();
      });
      return;
    }

    this.setState({
      loading: true,
    });

    var data = {
      appId: e.appId,
      entryId: e.entryId,
      formId: e.formId || e.entryId,
      dataId: e.dataId || e.data._id,
      authGroupId: e.authGroupId,
      ignoreOptAuth: e.ignoreOptAuth ? e.ignoreOptAuth : undefined,
      popupFormPath: e.popupFormPath,
      flowType: e.flowType,
      flowId: e.flowId,
      widgetId: e.widgetId, //报表控件id
      refAppId: e.refAppId ? e.refAppId : undefined, //如果是跨应用 源数据表的应用id
      // extDashData:e.extDashData,
    };
    if (e.dataUrl == "/data/dash_process_data") {
      data.appId = e.extDashData.appId;
      data.entryId = e.extDashData.entryId;
      data.formId = e.extDashData.formId;
      data.widgetId = e.extDashData.widgetId;
      data.extDashData = e.extDashData;
      if (data.formId.indexOf("@") > -1) {
        data.formId = e.extDashData.formId.split("@")[0];
        if (data.appId != e.extDashData.formId.split("@")[1]) {
          data.refAppId = e.extDashData.formId.split("@")[1];
        }
      }
    }

    React.axios(e.dataUrl, data)
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            let flow = null;
            if (e.flowType && !e.flow) {
              flow = BsyUtils.getFlowOption(res.data, e.flowType);
              e.flow = flow;
            }

            let i = res.data;
            that.bakformdata = i;
            e.form = i.form;
            e.data = i.data;
            e.items = i.form.items;
            e.fields = i.fields;
            e.header = i.fields;
            e.fieldShowRules = i.form.fieldShowRules;
            e.subformFieldShowRules = i.form.subformFieldShowRules;
            e.optAuth = i.optAuth;
            e.ptlist = i.ptlist || e.ptlist;
            e.multiTabs = i.formTabs;
            e.formTabsStyle = i.formTabsStyle || {};
            e.hasEditBtn = i.hasEditBtn;
            e.hasDeleteBtn = i.hasDeleteBtn;
            e.hasComment = i.hasComment;
            e.hasCoop = i.hasCoop;
            e.hasCopy = i.hasCopy || false;
            e.formName = i.formName;
            e.hasFlow = i.hasFlow;
            e.hasFlowBtn = i.hasFlow && !i.hasCoop;
            e.hasLog = i.hasLog;
            e.hasLogView = e.ignoreAuth
              ? e.hasFlow
              : e.flow
                ? e.flow.hasLogView
                : i.hasLogView;
            e.hasFlowLog =
              (e.flow ? e.flow.hasLogView : i.hasLogView) ||
              i.hasFlowLog ||
              i.flow_log;
            // TODO 映射错误
            // e.hasFlowLog = i.hasFlowLog;
            e.hasPrintBtn = i.hasPrintBtn;
            e.flow_close = i.flow_close;
            e.flow_activate = i.flow_activate;
            e.flow_replace_node = i.flow_replace_node;
            e.flow_log = i.flow_log;
            e.flow_transfer = i.flow_transfer;
            e.widgetId = data.widgetId;
            that.INNERLINKbak = window.FX.STATIC.INNERLINK;
            window.FX.STATIC.INNERLINK = i.form._id;
            // if (e.dataUrl == "/data/dash_process_data") {
            // window.FX.STATIC.INNERLINK = i.form._id;
            // }

            // if (e.hasComment || e.hasLog || e.hasFlowLog) {
            e.css.width = 1080;
            // } else {
            //     e.css.width = 780;
            // }
            that.calculate();
            that.setState({ loading: false }, () => {
              this.showTabs();
              this._setLinkQuery();
              this.createFlowComments();
            });
          },
          () => {
            that.setState({ loading: false });
          }
        );
      })
      .catch((res) => {
        that.setState({ loading: false, error: true });
        console.error(res);
      });
  };

  _isEditable = () => {
    var a = this.options,
      b = a.hasEditBtn || a.hasDeleteBtn;
    if (a.data && a.data._id) {
      var c = a.data._id;
      return (
        b && c.toString().substring(0, 1) !== window.FX.DATA_PREFIX.Aggregate
      );
    }
    return !1;
  };

  updateShareFields = (isPublicData, showfield) => {
    const { data, header, allShowFields, appId, entryId } = this.options;
    // "/dashboard/app/" + FX.STATIC.APPID + "/entry/" + c.entryId + "/update"
    React.axios(
      "/dashboard/app/" +
      (data.appId || appId) +
      "/entry/" +
      (data.entryId || entryId) +
      "/update",
      {
        appId: data.appId,
        entryId: data.entryId,
        dataId: data._id,
        isPublicData: isPublicData,
        publicDataShowField: showfield, //外链可以查看的字段
        extDashData: this.extDashData(),
      }
    ).then((res) => {
      BsyUtils.showAjaxTip(
        res.data,
        () => { },
        () => { }
      );
    });
  };

  doShare = () => {
    const { data, header, allShowFields, appId, entryId } = this.options;
    var routUrl = window.root_directroy ? window.root_directroy + "/" : "";
    BsyDialog({
      title: React.language("share"),
      subTitle: React.language("form.link.subTitle"),
      height: 460,
      width: 600,
      theme: this.props.theme,
      noFooter: true,
      onContentCreate: (e) => {
        let ddfref = createRef();

        let items = [];

        header.map((item) => {
          item = this.widget2Item(item);
          if (!item || item.type == "dataload") {
            return;
          }
          items.push({
            text: item.title || item.text,
            value: item.tag || item.name,
            type: item.type,
            items: item.items,
          });
        });
        var tmpval = [];
        var fields = [];
        var allselect = false;
        window.FX.STATIC.PublicData = window.FX.STATIC.PublicData || {};
        if (
          BsyUtils.isObjectEmpty(
            window.FX.STATIC.PublicData.publicDataShowField
          )
        ) {
          allselect = true;
        }
        var tmpsub = ["ext"];
        BsyUtils.forEach(items, function (a1, b1) {
          if (b1.type === "button") {
            return;
          }
          b1.selected = allselect;
          if (allselect) {
            tmpval.push(b1.value);
          }

          if (b1.type === "subform") {
            BsyUtils.forEach(b1.items, function (a2, b2) {
              if (b2.type === "button") {
                return;
              }
              var bb = { ...b2 };
              bb.value = [b1.value, b2.name].join(".");
              bb.text = [b1.text, b2.text].join(".");
              bb.selected = allselect;
              if (allselect) {
                tmpval.push(bb.value);
              }
              fields.push(bb);
            });
            tmpsub.push(b1.name);
          } else fields.push(b1);
        });

        if (window.FX.STATIC.PublicData.publicDataShowField === undefined) {
          tmpval = [];
          BsyUtils.forEach(fields, function (a2, b2) {
            tmpval.push(b2.value);
          });
        } else {
          window.FX.Utils.forEach(
            window.FX.STATIC.PublicData.publicDataShowField,
            function (a1, b1) {
              if (tmpsub.indexOf(b1) == -1) {
                tmpval.push(b1);
              }
            }
          );
        }
        window.FX.STATIC.PublicData.publicDataShowField = tmpval;

        return (
          <div className="share-url-pane" ref={ddfref}>
            <div style={{ margin: "10px 0" }}>
              <span style={{ color: "#1F2D3D", marginRight: 20 }}>
                {React.language("release.team")}
              </span>
              <span style={{ fontSize: 12, color: "#999" }}>
                {React.language("release.team.link")}
              </span>
            </div>
            <BsyShareUrlPane
              url={
                window._bby_config.site +
                routUrl +
                "team/app/" +
                (data.appId || appId) +
                "/entry/" +
                (data.entryId || entryId) +
                "/data/" +
                data._id
              }
            ></BsyShareUrlPane>
            <div
              style={{
                borderTop: "solid 1px #e0e0e0",
                height: 0,
                margin: "20px 0",
              }}
            ></div>

            {window.hasJarvisbim ? (
              ""
            ) : (
              <>
                {!BsyUtils.isSysManager() ? (
                  ""
                ) : (
                  <div
                    style={{
                      margin: "10px 0",
                    }}
                  >
                    <span style={{ color: "#1F2D3D", marginRight: 20 }}>
                      {React.language("data.externalLink")}
                    </span>
                    <span style={{ fontSize: 12, color: "#999" }}>
                      {React.language("data.externalLink.subTitle")}
                    </span>
                  </div>
                )}

                {!BsyUtils.isSysManager() ? (
                  ""
                ) : (
                  <BsySwitchBtn
                    power={window.FX.STATIC.PublicData.isPublicData}
                    switchChange={(e) => {
                      var res = ddfref.current.querySelector(".outlimk");
                      if (res) {
                        if (e) {
                          res.style.display = "";
                        } else {
                          res.style.display = "none";
                        }
                        window.FX.STATIC.PublicData.isPublicData = e;
                        this.updateShareFields(
                          e,
                          window.FX.STATIC.PublicData.publicDataShowField
                        );
                      }
                    }}
                  ></BsySwitchBtn>
                )}

                <div
                  className="outlimk"
                  style={{
                    display: window.FX.STATIC.PublicData.isPublicData
                      ? ""
                      : "none",
                  }}
                >
                  <BsyShareUrlPane
                    url={
                      window._bby_config.site +
                      routUrl +
                      "team/l/" +
                      window.FX.STATIC.INNERLINK +
                      "/data/" +
                      data._id
                    }
                  ></BsyShareUrlPane>

                  {!BsyUtils.isSysManager() ? (
                    ""
                  ) : (
                    <>
                      <div style={{ margin: "5px 0px" }}>
                        {React.language("field.show")}
                      </div>
                      <BsySelectCheckBox
                        theme={this.props.theme}
                        items={fields}
                        value={tmpval}
                        hasSelectAll={true}
                        type={"combocheck"}
                        onStopEdit={(e1) => {
                          window.FX.STATIC.PublicData.publicDataShowField = e1;
                          this.updateShareFields(
                            window.FX.STATIC.PublicData.isPublicData,
                            window.FX.STATIC.PublicData.publicDataShowField
                          );
                        }}
                      ></BsySelectCheckBox>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        );
      },
    });
  };

  doSetFields = (t) => {
    let that = this;
    let e = this.options;
    if (!BsyUtils.isNull(e.showFields)) {
      let i = BsyUtils.getShowFieldItems(e.showFields, this.allFields);
      let value = [];
      BsyUtils.forEach(i, (index, data) => {
        if (data.selected) {
          value.push(data.value);
        }
      });
      BsyMsgBubble({
        anchor: t.target,
        contentHTML: () => {
          return (
            <TriggerComboCheckPane
              items={i}
              hasSelectAll={true}
              value={value}
              onSelect={(val) => {
                // that.selectItem(val)
                that.updateShowFields(val);
                e.showFields = BsyUtils.getShowFieldsByNames(
                  that.allFields,
                  val
                );
                that.subformRenderKey++;
                that.setState({});
              }}
              onSeach={this.onSeach}
            />
          );
        },
        text4Cancel: null,
        text4Ok: null,
        theme: this.props.theme,
        minWidth: 150,
        width: 230,
        contentPadding: 0,
        edge: 200,
        hAdjust: 72,
        dockPosition: "left",
        onClose: function () {
          return !1;
        },
      });
    }
  };

  _getPrintField = () => {
    var b = this,
      c = this.options;
    var printffields = [];
    BsyUtils.forEach(c.showFields, function (a1, b1) {
      if (b1) {
        if (b1.type != "subform") {
          printffields.push(b1.name);
        } else {
          BsyUtils.forEach(b1.items, function (a2, b2) {
            printffields.push([b1.name, b2.name].join("."));
          });
        }
      }
    });
    var fields = [];
    BsyUtils.forEach(printffields, function (a1, b1) {
      if (["flowState", "chargers"].indexOf(b1) == -1) {
        fields.push(b1);
      }
    });
    return fields;
  };

  _createPrintfList = (el, cb) => {
    var _this = this;
    var opt = this.options;
    let menu = [];

    if (opt.mode == "view") {
      showPrintList(opt.ptlist, cb);
    } else {
      if (!_this.ptlist && !BsyUtils.isObjectEmpty(opt.ptlist)) {
        _this.ptlist = opt.ptlist;
      }

      if (_this.ptlist) {
        showPrintList(_this.ptlist, cb);
      } else {
        React.axios("/data/printlist", {
          entryId: opt.entryId || window.FX.STATIC.ENTRYID,
          formId: opt.formId || opt.entryId || window.FX.STATIC.ENTRYID,
          appId: opt.appId || window.FX.STATIC.APPID,
          dataId: opt.data._id,
          flowId: opt.flow ? opt.flow.flowId : undefined,
          version: opt.flow ? opt.flow.flowVer || opt.flow.version : undefined,
        }).then((res) => {
          let ptlist = [];
          if (res.data.items.length > 0) {
            BsyUtils.forEach(res.data.items, (dd, item) => {
              // if (item.selected) {
              //     _this.printId = item.value;
              // }
              ptlist.push({
                id: item.value,
                name: item.text,
                printId: item.value,
              });
            });
            _this.ptlist = ptlist;
            showPrintList(_this.ptlist, cb);
          } else {
            cb && cb();
          }
        });
      }
    }

    function showPrintList(ptlist, cb) {
      if (ptlist.length == 1) {
        _this.printId = ptlist[0].printId || ptlist[0].id;
        cb && cb();
        return;
      }

      BsyUtils.forEach(ptlist, function (a1, b1) {
        let id = b1.printId || b1.id;
        menu.push({
          text: b1.name,
          colorType: "",
          extIcon: id === _this.printId ? "icon-ok" : "",
          extIconColor: "#0265ff",
          click: () => {
            _this.printId = b1.printId || b1.id;
            cb && cb();
          },
        });
      });
      BsyAlertMenu({
        item: menu,
        width: 220,
        target: el.target,
        onClose: () => { },
      });
    }
  };

  onMessage = (event) => {
    // console.log(event);

    if (event.data && "token" in event.data) {
      if (event.data.token === "printed-close") {
        this.showPane.closeAlter();
      }
    }
  };

  onDocumentClick = () => {
    window.removeEventListener("click", this.onDocumentClick, false);
    if (this.showPane) {
      this.showPane.closeAlter();
      this.showPane = null;
    }

    console.log("onDocumentClick 清理打印窗口");
  };

  _doPrint = () => {
    var b = this,
      c = this.options;
    if (!this.isPrinting) {
      if (b.printId == "system") {
        if (BsyUtils.isDingdingBrowser()) {
          BsyUtils.getDingdingLoginUrl(function (data) {
            BsyAlert({
              type: "query",
              title: React.language("corp.dingtalk.print.fail"),
              text4Ok: React.language("corp.dingtalk.print.ok"),
              text4Cancel: React.language("corp.dingtalk.print.cancel"),
              ok: function () {
                BsyUtils.redirectTo(data.url, "_blank");
              },
            });
          });

          return;
        } else {
          b._doSystemPrint();
          return;
        }
        // return void this._doSystemPrint();
      }

      this.isPrinting = !0;
      var d1 = BsyUtils.checkRefApp({
        appId: c.appId,
        entryId: c.entryId,
        formId: c.forms ? c.forms[0] : c.entryId,
      });

      let layerRef = null;
      BsyMaskLayer({
        // customCls: 'fadein-right',
        onContentCreate: (ref) => {
          layerRef = ref;
          return (
            <div>
              <BsySLoading />{" "}
            </div>
          );
        },
      });
      if (this.showPane) {
        window.removeEventListener("message", b.onMessage, false);
        this.showPane.closeAlter();
        this.showPane = null;
      } else {
        this.showPane = null;
      }
      let theme = "";
      var d = BsyUtils.isSupportPdf();
      React.axios("/data/_print", {
        scenes: window.FX.STATIC.QTOKEN ? "publicQuery" : c.originPrint,
        showFields: this._getPrintField(),
        appId: d1.appId,
        entryId: d1.entryId,
        formId: d1.formId || d1.entryId,
        refAppId: d1.refAppId,
        isAttachment: BsyUtils.isDingdingBrowser() ? false : !d,
        groupId: (b.printId ? b.printId : c.flow ? c.flow.printId : null)
          ? null
          : c.authGroupId, //c.authGroupId,  //兼容老的数据管理权限
        authGroupId: c.authGroupId,
        popupFormPath: c.popupFormPath,
        flowType: c.ignoreOptAuth ? null : c.flowType,
        flowId: c.flow && c.flow.flowId,
        flowVer: c.flow && c.flow.version,
        dataId: c.data._id,
        printId: b.printId ? b.printId : c.flow ? c.flow.printId : null,
        extDashData: b.extDashData(),
      })
        .then((res) => {
          b.isPrinting = false;
          layerRef.close();
          if ("system" === res.data.printType) {
            if (BsyUtils.isDingdingBrowser()) {
              BsyUtils.getDingdingLoginUrl(function (data) {
                BsyAlert({
                  type: "query",
                  title: React.language("corp.dingtalk.print.fail"),
                  text4Ok: React.language("corp.dingtalk.print.ok"),
                  text4Cancel: React.language("corp.dingtalk.print.cancel"),
                  ok: function () {
                    BsyUtils.redirectTo(data.url, "_blank");
                  },
                });
              });

              return;
            } else {
              b._doSystemPrint();
              return;
            }
          } else if ("template" === res.data.printType) {
            var pane;
            var title = "";
            var c = res.data;
            if (res.data.url.indexOf("readpdf") > -1) {
              title = React.language("data.pdf");

              pane = (
                <embed
                  src={res.data.url}
                  width="100%"
                  height="100%"
                  style={{ position: "absolute" }}
                  type="application/pdf"
                />
              );
            } else {
              var officeurl =
                window._bby_config.office_domain || "office.baibaoyun.com";
              var url = "";
              if (c.url.indexOf("readword") > -1) {
                url =
                  "https://" +
                  officeurl +
                  "/op/view.aspx?src=" +
                  encodeURIComponent(window.location.origin + res.data.url);
              } else {
                url =
                  "https://" +
                  officeurl +
                  "/op/view.aspx?src=" +
                  encodeURIComponent(res.data.url);
              }
              pane = (
                <iframe
                  className="file-box-preview"
                  src={url}
                  title={title}
                  frameborder="0"
                  style={{ width: "100%", height: "100%" }}
                />
              );
              title = React.language("data.word");
            }
            if (d) {
              BsySlidePane({
                title: title,
                hasHeader: true,
                theme: theme,
                onClose: () => {
                  window.removeEventListener("message", b.onMessage, false);
                },
                onContentCreate: (ref) => {
                  b.showPane = ref;
                  const url = `${res.data.url}?filename=${res.data.filename}`;
                  return (
                    <>
                      <div className="preview-print-title">
                        <div className="fileName">{res.data.filename}</div>
                        <a className="fileDownloadBtn" href={url}>
                          <i clclassNameass="icon-download"></i>
                          {React.language("download")}
                        </a>
                      </div>
                      {pane}
                    </>
                  );
                },
              });
            } else {
              if (BsyUtils.isDingdingBrowser()) {
                React.axios("/sso/getJumpUrl", {
                  url: c.url,
                }).then((res) => {
                  BsyUtils.redirectTo(res.data.url, "_blank");
                });
                return;
              } else {
                BsyUtils.redirectTo(c.url);
              }
            }
          }
        })
        .catch((res) => {
          console.error(res);
          layerRef.close();
          b.isPrinting = false;
        });
    }
  };

  _doSystemPrint = () => {
    // BsySlidePane({
    //   title: "test",
    //   hasHeader: true,

    //   onContentCreate: (ref) => {
    //     return (
    //       <>

    //       </>
    //     );
    //   },
    // });
    // var a = this.options,
    //   b = new window.FX.FormPrint({
    //     title: a.title,
    //     header: a.showFields,
    //     comments: this.state.comments,
    //     layout: a.layout,
    //     data: a.data,
    //   });

    const printFields = this.options.showFields
      .filter((item) => {
        if (!item) {
          return false;
        }
        if (this.showRules && item.name in this.showRules) {
          return this.showRules[item.name];
        }
        if (item.name === "label") {
          return false;
        }
        return true;
      })

    BsyUtils.doPrint(
      <BsySystemPrint
        title={this.options.title}
        header={printFields}
        comments={this.state.comments}
        layout={this.options.layout}
        data={this.options.data}
      />,
      200
    );
  };

  _showTransferPane = () => {
    var b = this.options,
      c = this;

    var transactNodes = [];
    BsyUtils.forEach(this.transactNodes, function (_a, _b) {
      if (_b["value"] != -1) {
        transactNodes.push(_b);
      }
    });

    new window.FX.FlowTransferPane({
      renderEl: window.$("<div />").appendTo(window.$(c.element.current)),
      chargersMap: this.chargersMap,
      transactNodes: transactNodes,
      chargeNodes: this.chargeNodes,
      flowState: b.data.flowState,
      appId: b.appId,
      formId: b.formId || b.entryId,
      entryId: b.entryId || b.formId,
      authGroupId: b.authGroupId,
      popupFormPath: b.popupFormPath,
      dataId: b.data._id,
      extDashData: c.extDashData(),
      onAfterClose: function () {
        c.stateChanged = !0;
        BsyUtils.applyFunc(c, b.onClose, [c.stateChanged], !1);
      },
    });
  };

  _showReplacePane = () => {
    var b = this.options,
      c = this;

    var changeNodes = [];

    BsyUtils.forEach(this.changeNodes, function (_a, _b) {
      // if (_b['value'] != -1) {
      //     transactNodes.push(_b);
      // }
      if (_b["value"] != -1) {
        changeNodes.push(_b);
      }
    });

    // if(c.$flowWrapper)
    //     c.$flowWrapper.remove(),c.$flowWrapper = null;
    // c.$flowWrapper = $('<div class="flow-state" />').appendTo(c.element);

    new window.FX.FlowTransferPane({
      renderEl: window.$("<div />").appendTo(window.$(c.element.current)),
      chargersMap: this.chargersMap,
      is_dock_form: b.is_dock_form,
      changeNodes: changeNodes,
      chargeNodes: this.chargeNodes,
      flowState: b.data.flowState,
      flow_replace_node: b.flow_replace_node,
      appId: b.appId,
      formId: b.formId || b.entryId,
      entryId: b.entryId || b.formId,
      authGroupId: b.authGroupId,
      popupFormPath: b.popupFormPath,
      dataId: b.data._id,
      extDashData: c.extDashData(),
      onAfterClose: function () {
        c.stateChanged = !0;
        window.FX.Utils.applyFunc(c, b.onClose, [c.stateChanged], !1);
      },
    });
  };

  _getFlowInfo = (cb) => {
    var b = this,
      c = this.options;
    if (BsyUtils.isObjectEmpty(b.flows)) {
      window.FX.Utils.dataAjax(
        {
          url: "/data/workflows",
          data: {
            appId: c.appId,
            entryId: c.entryId,
            formId: c.formId || c.entryId,
            dataId: c.data._id,
            authGroupId: c.authGroupId,
            popupFormPath: c.popupFormPath,
            flowType: c.flowType,
            flowId: c.flowId,
            extDashData: b.extDashData(),
          },
        },
        function (h) {
          b.flows = h.flows;

          b.transactNodes = [];
          b.chargeNodes = [];
          b.chargersMap = [];
          b.changeNodes = [];
          var nodemap = {};
          BsyUtils.forEach(c.data.chargers, function (a1, b1) {
            if (!nodemap.hasOwnProperty(b1.flowId)) {
              b.chargeNodes.push({
                value: b1.flowId,
                text: b1.flowName,
              });
              nodemap[b1.flowId] = 1;
            }

            if (b1.userId) {
              if (!b.chargersMap.hasOwnProperty(b1.userId.split("@")[1])) {
                b.chargersMap[b1.userId.split("@")[1]] = [
                  b1.userId.split("@")[0],
                ];
              } else {
                b.chargersMap[b1.userId.split("@")[1]].push(
                  b1.userId.split("@")[0]
                );
              }
            }
          });
          var map = {};
          BsyUtils.forEach(h.flows, function (a1, b1) {
            if (
              b1.flowId != -1 &&
              (b1.type === "flow" || b1.type === "subflow")
            ) {
              if (!map.hasOwnProperty(b1.flowId)) {
                b.transactNodes.push({
                  value: b1.flowId,
                  text: b1.name,
                });
                b.changeNodes.push({
                  value: b1.flowId,
                  text: b1.name,
                });
                map[b1.flowId] = 1;
              }
            }
          });

          cb && cb();
        }
      );
    } else {
      cb && cb();
    }
  };

  renderMeunPane = () => {
    const {
      dataCount,
      dataIndex,
      onDeleteData,
      onEditData,
      onCopyData,
      onCloseFlow,
      ptlist,
      hasFlowBtn,
      data,
      hasDeleteBtn,
      hasEditBtn,
      hasCopy,
      hasPrintBtn,
      hasRecoverBtn,
      onRecoverData,
      hasShareBtn,
      hasSwitchBtn,
      flow_transfer,
      flow_close,
      flow_activate,
      flow_replace_node,
      mode,
    } = this.options;
    let that = this;

    if (this.state.error) {
      return "";
    }
    if (mode == "print") {
      return "";
    }
    return (
      <div className={"preview-edit-pane"}>
        <div className="edit-pane">
          {hasFlowBtn && data.hasOwnProperty("flowState") ? (
            <>
              {data.flowState == 0 ? (
                <>
                  {flow_close ? (
                    <a
                      className="close-btn"
                      onClick={(e) => {
                        BsyUtils.applyFunc(that, onCloseFlow, [], !1);
                      }}
                    >
                      <span>{React.language("flow.close")}</span>
                    </a>
                  ) : (
                    ""
                  )}
                  {flow_replace_node ? (
                    <a
                      className="activate-btn"
                      onClick={(e) => {
                        that._getFlowInfo(function () {
                          that._showReplacePane();
                        });
                      }}
                      onMouseEnter={(e) => {
                        window.FX.UI.showPopover({
                          position: "bottomLeft",
                          anchor: window.$(e.currentTarget),
                          edge: 12,
                          content: window
                            .$("<span/>")
                            .text(React.language("change.flow.node.tip")),
                          type: "dark",
                          // animation: !1
                        });
                      }}
                      onMouseLeave={(e) => {
                        window.FX.UI.closePopover();
                      }}
                    >
                      <span>{React.language("change.flow.node")}</span>
                    </a>
                  ) : (
                    ""
                  )}
                  {flow_transfer ? (
                    <a
                      className="transfer-btn"
                      onClick={(e) => {
                        that._getFlowInfo(function () {
                          that._showTransferPane();
                        });
                      }}
                      onMouseEnter={(e) => {
                        window.FX.UI.showPopover({
                          position: "bottomLeft",
                          anchor: window.$(e.currentTarget),
                          edge: 12,
                          content: window
                            .$("<span/>")
                            .text(React.language("flow.transfer.tip")),
                          type: "dark",
                          // animation: !1
                        });
                      }}
                      onMouseLeave={(e) => {
                        window.FX.UI.closePopover();
                      }}
                    >
                      <span>{React.language("flow.transfer")}</span>
                    </a>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <>
                  {" "}
                  {flow_activate ? (
                    <a
                      className="activate-btn"
                      onClick={(e) => {
                        that._getFlowInfo(function () {
                          that._showTransferPane();
                        });
                      }}
                    >
                      <span>{React.language("flow.activate")}</span>
                    </a>
                  ) : (
                    ""
                  )}
                </>
              )}
              <a className="line-btn"></a>
            </>
          ) : (
            ""
          )}
          {hasDeleteBtn ? (
            <a
              className="delete-btn"
              onClick={(e) => {
                BsyUtils.applyFunc(that, onDeleteData, [], !1);
              }}
              onMouseEnter={(e) => {
                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(e.currentTarget),
                  edge: 12,
                  content: window.$("<span/>").text(React.language("delete")),
                  type: "dark",
                  // animation: !1
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i className="icon-bby-trasho"></i>
            </a>
          ) : (
            ""
          )}
          {hasCopy ? (
            <a
              className="copy-btn"
              onClick={(e) => {
                BsyUtils.applyFunc(that, onCopyData, [that.options], !1);
              }}
              onMouseEnter={(e) => {
                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(e.currentTarget),
                  edge: 12,
                  content: window.$("<span/>").text(React.language("copy")),
                  type: "dark",
                  // animation: !1
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i className="icon-bsy-enterprise-log"></i>
            </a>
          ) : (
            ""
          )}

          {hasEditBtn ? (
            <a
              className="edit-btn"
              onClick={(e) => {
                that.unbindKey();
                BsyUtils.applyFunc(that, onEditData, [that.options], !1);
              }}
              onMouseEnter={(e) => {
                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(e.currentTarget),
                  edge: 12,
                  content: window.$("<span/>").text(React.language("edit")),
                  type: "dark",
                  // animation: !1
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i className="icon-flow-edit"></i>
            </a>
          ) : (
            ""
          )}
          {hasPrintBtn ? (
            <>
              <a
                className="print-btn"
                onClick={(e) => {
                  if (BsyUtils.isObjectEmpty(ptlist)) {
                    that._doPrint();
                  } else {
                    if (ptlist.length == 1) {
                      that.printId = ptlist[0].printId || ptlist[0].id;
                      that._doPrint();
                    } else {
                      //数据内链
                      that._createPrintfList(e, function () {
                        that._doPrint();
                      });
                    }
                  }
                }}
                onMouseEnter={(e) => {
                  window.FX.UI.showPopover({
                    position: "bottomLeft",
                    anchor: window.$(e.currentTarget),
                    edge: 12,
                    content: window.$("<span/>").text(React.language("print")),
                    type: "dark",
                    // animation: !1
                  });
                }}
                onMouseLeave={(e) => {
                  window.FX.UI.closePopover();
                }}
              >
                <i className="icon-print"></i>
              </a>
              <a className="line-btn"></a>
            </>
          ) : (
            ""
          )}
          {!window.FX.STATIC.FTOKEN && hasShareBtn ? (
            <a
              className="share-btn"
              onClick={(e) => {
                that.doShare();
              }}
              onMouseEnter={(e) => {
                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(e.currentTarget),
                  edge: 12,
                  content: window.$("<span/>").text(React.language("share")),
                  type: "dark",
                  // animation: !1
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i className="icon-bby-share"></i>
            </a>
          ) : (
            ""
          )}
          {hasRecoverBtn ? (
            <a
              className="operation"
              onClick={(e) => {
                BsyUtils.applyFunc(that, onRecoverData, [data._id, true], !1);
              }}
              onMouseEnter={(e) => {
                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(e.currentTarget),
                  edge: 12,
                  content: window.$("<span/>").text(React.language("recover")),
                  type: "dark",
                  // animation: !1
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i className="icon-bsy-restore"></i>
            </a>
          ) : (
            ""
          )}
          {hasRecoverBtn ? (
            <a
              className="operation style-red "
              onClick={(e) => {
                BsyUtils.applyFunc(that, onRecoverData, [data._id, false], !1);
              }}
              onMouseEnter={(e) => {
                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(e.currentTarget),
                  edge: 12,
                  content: window
                    .$("<span/>")
                    .text(React.language("delete.hard")),
                  type: "dark",
                  // animation: !1
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i className="icon-bby-trasho"></i>
            </a>
          ) : (
            ""
          )}
          <a
            className="show-fields-btn active"
            onClick={(e) => {
              this.doSetFields(e);
            }}
            onMouseEnter={(e) => {
              window.FX.UI.showPopover({
                position: "bottomLeft",
                anchor: window.$(e.currentTarget),
                edge: 12,
                content: window.$("<span/>").text(React.language("field.show")),
                type: "dark",
                // animation: !1
              });
            }}
            onMouseLeave={(e) => {
              window.FX.UI.closePopover();
            }}
          >
            <i className="icon-page-view"></i>
          </a>
        </div>

        {hasSwitchBtn ? (
          <div className="switch-pane">
            <div
              className={
                "switch-btn prev " + (dataIndex <= 1 ? "disabled" : "")
              }
              onMouseEnter={(e) => {
                if (!e.currentTarget.classList.contains("disabled")) {
                  window.FX.UI.showPopover({
                    position: "bottomLeft",
                    anchor: window.$(e.currentTarget),
                    edge: 12,
                    content: window
                      .$("<span/>")
                      .text(React.language("data.prev.tip")),
                    type: "dark",
                    // animation: !1
                  });
                }
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i
                className="icon-angleleft"
                onClick={(e) => {
                  this._switchData(dataIndex - 1);
                  window.FX.UI.closePopover();
                }}
              ></i>
            </div>
            <div className="switch-num">{`${dataIndex}/${dataCount}`}</div>
            <div
              className={
                "switch-btn next " +
                (dataIndex > dataCount - 1 ? "disabled" : "")
              }
              onMouseEnter={(e) => {
                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(e.currentTarget),
                  edge: 12,
                  content: window
                    .$("<span/>")
                    .text(React.language("data.next.tip")),
                  type: "dark",
                  // animation: !1
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
            >
              <i
                className="icon-angleright"
                onClick={(e) => {
                  this._switchData(dataIndex + 1);
                  window.FX.UI.closePopover();
                }}
              ></i>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  _createFlowStatePane = (a) => {
    var b = this.options,
      c = this;
    if (c.showFlowChart) {
      return;
    }

    var chargers = [];
    BsyUtils.forEach(b.data.chargers, function (a1, b1) {
      chargers.push(b1.userId || b1);
    });
    c.showFlowChart = true;
    this.flowStatePane = new window.FX.FlowStatePane({
      renderEl: window
        .$("<div class='flow-state' />")
        .css("z-index", window.FX.STATIC.zIndex++)
        .appendTo(window.$(c.element.current)),
      appId: b.appId || window.FX.STATIC.APPID,
      entryId: b.entryId || b.entryId,
      formId: b.formId || b.entryId,
      refAppId: b.refAppId,
      width: 780,
      dataId: b.data._id,
      flow: {
        flowStack: b.data.flowStack,
        flowState: b.data.flowState,
        hasLogView: !0,
        dataId: b.data._id,
        chargers: b.data.chargers,
        version: b.data.flowVer,
      },
      hasTransfer: b.ignoreVisible,
      flow_activate: b.flow_activate !== !1,
      flow_transfer: b.flow_transfer !== !1,
      flow_close: b.flow_close !== !1,
      logs: this.state.logs,
      hasClose: !0,
      hasTitle: !0,
      popupFormPath: b.popupFormPath,
      onClose: function (a) {
        c.showFlowChart = false;
      },
    });
  };

  renderTitle = () => {
    const { showForms, showFormIndex, formName, title, data } = this.options;

    if (showForms.length < 2) {
      let text = data.label || formName || title;
      return <span className="item ">{text}</span>;
    }

    return (
      <>
        {showForms.map((item, index) => {
          let text = item.data.label || item.formName || item.title;

          if (index == 0) {
            return (
              <span
                className="item go"
                onClick={(event) => {
                  if (this.props.onSwitchForm) {
                    this.props.onSwitchForm(index);
                  }
                }}
              >
                {text}
              </span>
            );
          }

          if (index != showFormIndex) {
            return (
              <>
                /
                <span
                  className="item go"
                  onClick={(event) => {
                    if (this.props.onSwitchForm) {
                      this.props.onSwitchForm(index);
                    }
                  }}
                >
                  {text}
                </span>
              </>
            );
          }

          return (
            <>
              /<span className="item ">{text}</span>
            </>
          );
        })}
      </>
    );
  };

  renderHeader = () => {
    const {
      flowId,
      onClose,
      formName,
      title,
      data,
      flow,
      hasLogView,
      showFormIndex,
      hasFlowBtn,
    } = this.options;
    //flow && FX.Utils.isArray(c.flow.flowNodes) && c.flow.flowNodes.length > 1

    return (
      <div className="preview-title-pane">
        {onClose ? (
          <i
            className="icon-close-large form-data-exit-icon"
            onClick={(e) => {
              if (this.showPane) {
                window.removeEventListener("message", this.onMessage, false);
                this.showPane.closeAlter();
                this.showPane = null;
              }

              if (this.props.onSwitchForm && showFormIndex > 0) {
                this.props.onSwitchForm(showFormIndex - 1);
              } else {
                onClose && onClose(!1);
              }
            }}
          ></i>
        ) : (
          ""
        )}

        <div
          className="all"
          onClick={(e) => {
            this.isFull = this.isFull == "true" ? "false" : "true";
            this.setfullscreenStatus(this.isFull);
            let i1 = e.currentTarget.querySelector("i");
            let parent = BsyUtils.closestClass(
              e.currentTarget,
              "bsy-form-pane"
            );
            let parent1 = BsyUtils.closestClass(
              e.currentTarget,
              "bsy-form-edit-pane"
            );

            i1.className = "";
            if (this.isFull == "true") {
              if (parent) parent.style.width = "100%";
              if (parent1) {
                parent1.style.width = "100%";
              }
              i1.classList.add("icon-bby-collapse");
            } else {
              if (parent) parent.style.width = "80%";
              if (parent1) {
                if (parent) parent.style.width = "100%";
                parent1.style.width = "80%";
              }
              i1.classList.add("icon-bby-expansion");
            }
          }}
        >
          <i className="icon-bby-iconquanping icon-bby-expansion"></i>
        </div>
        {!window.FX.STATIC.TOKEN ? (
          <>
            {!window.FX.STATIC.TOKEN && hasLogView ? (
              <div
                className="flow-chart"
                onClick={(e) => {
                  this._createFlowStatePane();
                }}
              >
                <i className="icon-form-flow"> </i>
                <span>{React.language("field.flow.chart")}</span>
              </div>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}

        {flow &&
          BsyUtils.isArray(flow.flowNodes) &&
          flow.flowNodes.length > 1 ? (
          <BsyNavigator
            items={flow.flowNodes}
            currentMenuId={flowId}
            menuKey={"flowId"}
            onMenuClick={(e) => {
              this.options.flowId = e;
              this.props.onFlowNodeClick && this.props.onFlowNodeClick(e);
            }}
          ></BsyNavigator>
        ) : (
          <div
            className="preview-title left"
            title={data.label || formName || title}
          >
            {this.renderTitle()}
          </div>
        )}
      </div>
    );
  };

  formatData = (item, dtv, mode) => {
    const {
      data,
      appId,
      formId,
      entryId,
      is_dock_form,
      extDashData,
      widgetId,
      optAuth,
      authGroupId,
      ignoreAuth,
      items,
      popupFormPath,
      refAppId,
    } = this.options;
    let that = this;
    let valtmp = dtv || data;
    let val = valtmp.hasOwnProperty(item.tag || item.name)
      ? valtmp[item.tag || item.name]
      : "";
    let auth = optAuth ? (optAuth[item.name] ? optAuth[item.name] : {}) : {};
    let widget = {};
    if (items) {
      items.map((res) => {
        if (res.widget.widgetName === item.name) {
          widget = res.widget;
        }
      });
    }

    if ((authGroupId === -4 || ignoreAuth) && !optAuth) {
      auth.is_file_down = true;
      auth.online_edit = true;
      auth.online_edit_record = true;
    }
    if (item.name === "label") {
      return val;
    }

    switch (item.type) {
      case "location":
      case "address": {
        if (val) {
          return (
            <div className="bsy_form_item_disable">
              {BsyUtils.address2Str(val, item.format || "pcda", "-")}
            </div>
          );
        }
        return "";
      }
      case "textarea": {
        if (!BsyUtils.isObjectEmpty(val)) {
          return (
            <BsyTextArea
              appId={appId}
              formId={formId || entryId}
              dataId={valtmp._id}
              entryId={entryId}
              enable={false}
              value={val}
            />
          );
        }
        return "";
      }
      case "separator": {
        return <BsySeparator {...item}></BsySeparator>;
      }
      case "sn":
      case "text": {
        if (!BsyUtils.isObjectEmpty(val)) {
          return (
            <BsyTextEditor
              appId={appId}
              formId={formId || entryId}
              dataId={valtmp._id}
              entryId={entryId}
              regex={item.regex}
              enable={false}
              value={val}
            />
          );
        }
        return "";
      }
      case "number": {
        if (!BsyUtils.isObjectEmpty(val)) {
          return (
            <BsyNumber
              appId={appId}
              formId={formId || entryId}
              entryId={entryId}
              format={item.format}
              afterSuffix={item.afterSuffix}
              displayMode={item.displayMode}
              precision={item.precision}
              thousandsSeparator={item.thousandsSeparator}
              notround={item.notround}
              enable={false}
              value={val}
            />
          );
        }
        return "";
      }
      case "upload": {
        if (!BsyUtils.isObjectEmpty(val)) {
          return (
            <BsyFileUpload
              authGroupId={authGroupId}
              appId={appId}
              formId={formId || entryId}
              dataId={valtmp._id}
              widgetName={item.name}
              fileName={item.name}
              entryId={entryId}
              enable={false}
              formMode={"formdata"}
              onGetAuth={() => {
                return auth;
              }}
              is_file_down={auth.is_file_down}
              check_image_exif={widget.check_image_exif}
              online_edit={auth.online_edit}
              online_edit_record={auth.online_edit_record}
              value={val}
            />
          );
        }
        return "";
      }
      case "flowState":
      case "flowstate": {
        let u = window.FX.CONST.WORKFLOW.FLOWSTATE;
        val = parseInt(val);
        let h = {};
        h[u.INPROCESS] = React.language("flow.state.inProcess");
        h[u.COMPLETE] = React.language("flow.state.complete");
        h[u.CLOSE] = React.language("flow.state.closed");

        return (
          <div className={`flowstate-btn f${val}`}>{h[val] ? h[val] : ""}</div>
        );
      }
      case "flowDecision":
      case "flowdecision": {
        if (!val) {
          return "";
        }
        var e1 = {};
        e1[0] = React.language("filter.method.ep");
        e1[1] = React.language("approved");
        e1[2] = React.language("approval.rejected");
        if (val) {
          if (parseInt(val.state_id)) {
            return e1[parseInt(val.state_id)];
          }
          return val.state;
        }
        break;
      }
      case "image": {
        if (!BsyUtils.isObjectEmpty(val)) {
          return (
            <BsyFileUpload
              appId={appId}
              dataId={valtmp._id}
              formId={formId || entryId}
              entryId={entryId}
              enable={false}
              is_file_down={auth.is_file_down}
              check_image_exif={widget.check_image_exif}
              value={val}
            />
          );
        }
        return "";
      }
      case "signature": {
        if (!BsyUtils.isObjectEmpty(val)) {
          return (
            <BsySignature
              appId={appId}
              dataId={valtmp._id}
              formId={formId || entryId}
              entryId={entryId}
              enable={false}
              value={val}
            />
          );
        }
        return "";
      }
      case "linkdata": {
        if (!BsyUtils.isObjectEmpty(val)) {
          return (
            <BsyLinkData
              {...item}
              form={this}
              extDashData={extDashData}
              widgetId={widgetId}
              appId={appId}
              designAppId={refAppId || appId}
              designEntryId={formId || entryId}
              designDataId={valtmp._id}
              dataId={valtmp._id}
              formId={formId || entryId}
              entryId={entryId}
              enable={false}
              value={val}
              popupFormPath={popupFormPath}
            />
          );
        }
        return "";
      }
      case "linkquery": {
        return (
          <BsyLinkQuery
            getContext={(context) => {
              this.linkquerys.push(context);
            }}
            onShowData={(data) => {
              if (that.props.onShowData)
                that.props.onShowData({ ...data, isFull: that.isFull });
            }}
            onGetFilter={(e) => {
              return that._getLinkQueryFilter(item);
            }}
            {...item}
            form={this}
            extDashData={extDashData}
            widgetId={widgetId}
            dataId={valtmp._id}
            widgetName={item.name}
            appId={appId}
            formId={formId || entryId}
            entryId={entryId}
            designAppId={refAppId || appId}
            designEntryId={formId || entryId}
            popupFormPath={popupFormPath}
          // allowAdd={false}
          />
        );
      }
      case "subform": {
        return this.createSubform(item, val);
      }
      case "radiogroup":
      case "combo": {
        if (val) {
          if (item.colorEnable) {
            return (
              <BsyTagList
                customCls={"bsy_form_item_disable"}
                header={item}
                data={[val]}
              />
            );
          }
          return <div className={"bsy_form_item_disable"}>{val}</div>;
        }
        return "";
      }
      case "checkboxgroup":
      case "combocheck": {
        if (Array.isArray(val)) {
          if (item.colorEnable) {
            return (
              <BsyTagList
                customCls={"bsy_form_item_disable"}
                header={item}
                data={val}
              />
            );
          }
          return <div className={"bsy_form_item_disable"}>{val.join(",")}</div>;
        }
        return "";
      }
      case "datetime": {
        if (val) {
          val = BsyUtils.date2Str(dayjsUtils.timeToTZ(val), item.format || "yyyy-MM-dd");
        }
        return <div className={"bsy_form_item_disable"}>{val}</div>;
      }
      case "usergroup":
      case "deptgroup": {
        if (val) {
          return (
            <div className="widget-user-dept-list">
              {val.map((item1) => {
                if (item.type === "usergroup") {
                  let bg = {};

                  if (item1 && (item1.name || item1.nickname))
                    bg = BsyUtils.formatUserThumb(item1.name || item1.nickname);
                  return (
                    <div
                      className="select-item member"
                      id={item1._id}
                      onClick={(e) => {
                        BsyUtils.showUserInfo(
                          null,
                          item1,
                          e,
                          appId,
                          is_dock_form
                        );
                      }}
                    >
                      {item1 && item1.avatarurl ? (
                        <img
                          className="user-center"
                          alt=""
                          src={item1.avatarurl}
                        ></img>
                      ) : (
                        <span
                          className={
                            "table-user-portrait-name color-" + (bg?.color || 0)
                          }
                        >
                          <span>{bg?.name?.[0] || ""}</span>
                        </span>
                      )}
                      <span>{BsyUtils._toDeptUser(item1)}</span>
                    </div>
                  );
                } else {
                  return (
                    <div
                      className="select-item dept"
                      onClick={(e) => {
                        BsyUtils.showUserInfo(
                          item1,
                          null,
                          e,
                          appId,
                          is_dock_form
                        );
                      }}
                    >
                      <i
                        className={`select-icon ${item1.type === "outsiderGroup" ||
                          item1.mode === "outsider"
                          ? "icon-outsider-group"
                          : item1.type === "dockcorp"
                            ? "icon-bby-iconqiyeshezhi"
                            : "icon-department"
                          }`}
                      ></i>
                      {/*{item1.type === "dockdept" && !!item1.dept_corp && <span style={{margin: '0 2px 0 0'}}>{item1.dept_corp + " - "}</span>}*/}
                      <span>{BsyUtils._toDeptUser(item1)}</span>
                      {/*{item1.type === "dockcorp" && <span style={{color: '#999','margin-left': '6px','font-size': '14px'}}>({React.language('contact.docking.people')})</span>}*/}
                    </div>
                  );
                }
              })}
            </div>
          );
        }
        return "";
      }

      case "dept": {
        if (val) {
          return (
            <div className="widget-user-dept-list">
              <div
                className="select-item dept"
                onClick={(e) => {
                  BsyUtils.showUserInfo(val, null, e, appId, is_dock_form);
                }}
              >
                <i
                  className={`select-icon ${val.type === "outsiderGroup" || val.mode === "outsider"
                    ? "icon-outsider-group"
                    : val.type === "dockcorp"
                      ? "icon-bby-iconqiyeshezhi"
                      : "icon-department"
                    }`}
                ></i>
                {/*{val.type === "dockdept" && !!val.dept_corp && <span style={{margin: '0 2px 0 0'}}>{val.dept_corp + " - "}</span>}*/}
                <span>{BsyUtils._toDeptUser(val)}</span>
                {/*{val.type === "dockcorp" && <span style={{color: '#999','margin-left': '6px','font-size': '14px'}}>({React.language('contact.docking.people')})</span>}*/}
              </div>
            </div>
          );
        }
        return "";
      }
      case "user": {
        if (val) {
          let bg = {};

          if (val && (val.name || val.nickname))
            bg = BsyUtils.formatUserThumb(val.name || val.nickname);

          return (
            <div className="widget-user-dept-list">
              {" "}
              <div
                className="select-item member"
                id={val._id}
                onClick={(e) => {
                  BsyUtils.showUserInfo(null, val, e, appId, is_dock_form);
                }}
              >
                {val && val.avatarurl ? (
                  <img className="user-center" alt="" src={val.avatarurl}></img>
                ) : (
                  <span
                    className={
                      "table-user-portrait-name color-" + (bg?.color || 0)
                    }
                  >
                    <span>{bg?.name?.[0] || ""}</span>
                  </span>
                )}
                <span>{BsyUtils._toDeptUser(val)}</span>
              </div>
            </div>
          );
        }
        return "";
      }
      case "chargers": {
        if (val) {
          if (mode === "current-node") {
            let nodes = [];
            val.map((item) => {
              if (nodes.indexOf(item.flowName) === -1) {
                nodes.push(item.flowName);
              }
              return null;
            });
            return nodes.join("、");
          }
          if (mode === "current-user") {
            let usd = [];
            return (
              <div className="widget-user-dept-list">
                {val.map((item) => {
                  let dda = {
                    _id: item.userId.split("@")[0],
                    name: item.userNickname,
                  };
                  if (!dda.name) {
                    return "";
                  }

                  if (usd.indexOf(dda._id) > -1) {
                    return "";
                  }

                  usd.push(dda._id);

                  let bg = {};

                  if (dda && (dda.name || dda.nickname))
                    bg = BsyUtils.formatUserThumb(dda.name || dda.nickname);
                  return (
                    <div
                      className="select-item member"
                      id={dda._id}
                      onClick={(e) => {
                        BsyUtils.showUserInfo(
                          null,
                          dda,
                          e,
                          appId,
                          is_dock_form
                        );
                      }}
                    >
                      {dda && dda.avatarurl ? (
                        <img
                          className="user-center"
                          alt=""
                          src={dda.avatarurl}
                        ></img>
                      ) : (
                        <span
                          className={
                            "table-user-portrait-name color-" + bg.color
                          }
                        >
                          <span>{bg.name[0]}</span>
                        </span>
                      )}
                      <span>{BsyUtils._toDeptUser(dda)}</span>
                    </div>
                  );
                })}
              </div>
            );
          }
        }
        return "";
      }
      default: {
        return val;
      }
    }
  };

  _getLinkQueryFilter = (b) => {
    var _opt = this.options;
    if (!b.linkFilter) {
      return null;
    }

    var that = this;
    var f = {},
      g = [],
      h = b.linkForm,
      refAppid = b.refAppid;
    var row = b.rowIdx;
    var data = this.options.data;
    var dd = [];
    if (!that.fieldMap && _opt.form) {
      // _.fieldMap = {};
      // FX.Utils.forEach(this.options.header,function(a1,b1){
      //     _.fieldMap[b1.name] = b1;
      // })
      that.fieldMap = {};
      BsyUtils.forEach(_opt.form.items, function (a1, b1) {
        that.fieldMap[b1.widget.widgetName] = {
          text: b1.label,
          type: b1.widget.type,
          name: b1.widget.widgetName,
          items: b1.widget.items,
          format: b1.widget.format,
        };
        if (b1.widget.type == "subform") {
          BsyUtils.forEach(b1.widget.items, function (i, subitem) {
            that.fieldMap[
              [b1.widget.widgetName, subitem.widget.widgetName].join(".")
            ] = {
              text: [b1.label, subitem.label].join("."),
              type: subitem.widget.type,
              name: [b1.widget.widgetName, subitem.widget.widgetName].join("."),
              items: subitem.widget.items,
              format: subitem.widget.format,
            };
          });
        }
      });
    }

    var i = true;
    var linkFilter = JSON.parse(JSON.stringify(b.linkFilter));
    if (BsyUtils.isArray(linkFilter)) {
      //老的模式
      BsyUtils.forEach(linkFilter, function (a, b) {
        var d = that.fieldMap[b.rely];
        var f = data[b.rely];

        if (d) {
          return BsyUtils.isObjectEmpty(d)
            ? ((i = !1), !1)
            : void g.push(that._createDataFilter(d, f, b.link));
        }
      });
      if (i) {
        if (!BsyUtils.isObjectEmpty(g)) {
          return (f[h] = g), f;
        }
      } else {
        return null;
      }
    } else {
      if (
        !BsyUtils.isObjectEmpty(linkFilter) &&
        !BsyUtils.isObjectEmpty(linkFilter.cond)
      ) {
        BsyUtils.forEach(linkFilter.cond, function (a, b) {
          b.form =
            !refAppid || window.FX.STATIC.APPID == refAppid
              ? h
              : [h, refAppid].join("@");

          if (b.valueMode == "depend") {
            var tt = [];
            BsyUtils.forEach(b.value, function (k, name) {
              if (that.fieldMap && that.fieldMap.hasOwnProperty(name)) {
                var d = data[name];
                if (BsyUtils._isSubformWidget(name)) {
                  var names = name.split(".");
                  let subform = names[0];
                  let subfield = names[1];
                  if (data[subform]) {
                    if (data[subform][row]) {
                      d = data[subform][row][subfield];
                    }
                  }
                }
                switch (that.fieldMap[name].type) {
                  case "datetime": {
                    if (d) {
                      tt.push(BsyUtils.date2Str(dayjsUtils.timeToTZ(d),
                        that.fieldMap[name].format || "yyyy-MM-dd"));
                    }
                    break;
                  }
                  case "user":
                  case "dept": {
                    if (d) {
                      tt.push(d._id || d.id);
                    } else {
                      i = false;
                    }
                    break;
                  }
                  case "usergroup":
                  case "deptgroup": {
                    BsyUtils.forEach(d, function (index, groupval) {
                      if (groupval) {
                        tt.push(groupval._id || groupval.id);
                      }
                    });
                    break;
                  }
                  case "linkdata": {
                    if (d) {
                      tt.push(d.key);
                    }
                    break;
                  }
                  default: {
                    if (Array.isArray(d)) {
                      if (!BsyUtils.isObjectEmpty(d)) {
                        tt = tt.concat(d);
                      } else {
                        i = false;
                      }
                    } else if (!BsyUtils.isObjectEmpty(d)) {
                      tt.push(d);
                    } else {
                      i = false;
                    }
                    break;
                  }
                }
              }
            });
            b.value = tt;
          }
          if (!BsyUtils.isObjectEmpty(b.value)) {
            dd.push(1);
          }
        });
        if (i) {
          return linkFilter;
        }
      }
    }
    return null;
  };
  createSubform = (item, value) => {
    let that = this;
    let o = this.options;
    let tmpitems = item.items;
    let subform = item.name;
    const { authGroupId, ignoreAuth, optAuth } = o;
    // that.hidecols = {};
    // that.hidecols[subform] = {};

    const subformFormItems = this.options.items
      ? this.options.items.find((i) => i.widget.widgetName === item.name)
        ?.widget.items
      : [];
    // if (that.hidecols && that.hidecols[item.name]) {
    //     tmpitems = [];
    //     BsyUtils.forEach(item.items, (key, val) => {
    //         if (that.hidecols[item.name].hasOwnProperty(val.name) && !that.hidecols[item.name][val.name]) {
    //             return true;
    //         }
    //         tmpitems.push(val);
    //     })
    // }
    let subformItems = {};
    let items = o.items ? o.items : o.form ? o.form.items : [];
    for (let i = 0; i < items.length; i++) {
      if (items[i].widget.widgetName === item.name) {
        subformItems = items[i];
      }
    }

    let widgetItems = [];
    let subname = item.name;
    if (tmpitems) {
      for (let index = 0; index < tmpitems.length; index++) {
        const element = tmpitems[index];
        let colname = [subform, element.name].join(".");
        let auth = optAuth ? optAuth[colname] : {};
        if ((authGroupId === -4 || ignoreAuth) && !optAuth) {
          auth.is_file_down = true;
          auth.online_edit = true;
          auth.online_edit_record = true;
        }

        if (["dataload", "button"].includes(element.type)) {
          continue;
        }

        if (!o.ignoreOptAuth) {
          if (o.flowType) {
            if (o.optAuth && !o.optAuth.hasOwnProperty(colname)) {
              continue;
            }
            if (o.optAuth && !o.optAuth[colname].visible) {
              continue;
            }
          }

          if (
            that.subColumnVisibleMaps &&
            that.subColumnVisibleMaps[subform] &&
            that.subColumnVisibleMaps[subform][element.name] === true
          ) {
            continue;
          }
        }

        let subformItem = {};
        if (subformItems.widget) {
          for (let l = 0; l < subformItems.widget.items.length; l++) {
            if (
              element.name === subformItems.widget.items[l].widget.widgetName
            ) {
              subformItem.fieldWidth =
                subformItems.widget.items[l].widget.fieldWidth;
            }
          }
        }

        const widget = subformFormItems?.find(
          (i) => i.widget.widgetName === element.name
        )?.widget || {}

        let config = {
          label: element.text || element.label,
          widget: {
            ...(element.widget ? element.widget : element),
            ...widget,
            ...auth,
            ...subformItem,
            afterSuffix: (element.widget ? element.widget : element).afterSuffix?.[React.i18n.language] ?
              (element.widget ? element.widget : element).afterSuffix :
              widget.afterSuffix,
            text: element.btnText,
            subform: subname,
            widgetName: element.widget
              ? element.widget.widgetName
              : element.name,
            // mode: element.type == 'button' ? 'blue' : undefined,
            enable: false,
            visible: true,
          },
        };

        widgetItems.push(config);
      }
    }

    let config = {
      appId: o.appId,
      formId: o.formId,
      dataId: o.dataId,
      designAppId: o.appId,
      designEntryId: o.formId || o.entryId,
      designDataId: o.dataId,
      widgetName: subname,
      subform_create: false,
      subform_insert: false,
      subform_edit: false,
      subform_sort: false,
      subform_delete: false,
      subform_import: false,
      subform_dataload: false,
      items: widgetItems,
      authGroupId: authGroupId,
      rootElement: this.element.current,
      value: value,
      label: item.text,
      isformdata: true,
      optAuth: optAuth,
      // sticky_column: this.options.items?.find(
      //   (i) => i.widget.widgetName === item.name
      // )?.widget.sticky_column,
      onGetFilter: (e) => {
        return that._getLinkQueryFilter(e);
      },
    };

    return <BsySubform
      key={`subform${this.subformRenderKey}`}
      {...config}></BsySubform>;
  };

  createFlowCommentsPane = () => {
    // return '';

    const { comments } = this.state;

    BsyUtils.forEach(comments, function (a, b) {
      if (b.comment || (b.signature && b.signature.length > 0)) return !1;
    });

    if (BsyUtils.isObjectEmpty(comments)) {
      return "";
    }

    return (
      <BsyFlowComment customCls={"print"} comments={comments}></BsyFlowComment>
    );
  };

  buttonEvent = (widgetName, subrowIndex, event) => {
    const { form, appId, formId, entryId } = this.options;

    this.rowRely = new rowExecuteRely_3_0({
      appId: appId,
      formId: formId || entryId,
      items: form.items,

      // firstWidget:  triggerThis.options.subform ? [triggerThis.options.subform,triggerThis.options.widgetName].join('.') : triggerThis.options.widgetName,
      // subformRow:$(triggerThis.element).closest(".subform-row").index(),
      // form: this,
      onWidgetError: (widget, clear) => { },
    });

    // this.formManager.buttonEvent(widgetName, subrowIndex, event);
  };

  widget2Item = (item) => {
    const { items } = this.options;
    if (item.widget) {
      if (item.widget.type == "separator") {
        item = {
          id: item.formId,
          text: item.label,
          name: item.widget.widgetName,
          type: item.widget.type,
          tab: item.tab,
        };
        items.map((e) => {
          if (e.widget.widgetName === item.name) {
            item.lineStyle = e.widget.lineStyle;
          }
          return null;
        });
      } else if (
        item.widget.type === "linkquery" ||
        item.widget.type === "linkquery"
      ) {
        // TODO 此关联查询设计的是多条展示 查看单条数据页面，展示的是单条
        item = {
          id: item.formId,
          text: item.label,
          name: item.widget.widgetName,
          type: item.widget.type,
          tab: item.tab,
          ...item.widget,
          form: this,
          linkFields: item.widget.linkFields,
          linkFilter: item.widget.linkFilter,
          linkForm: item.widget.linkForm,
          refAppId: item.widget.refAppId,
        };
        items.map((e) => {
          if (e.widget.widgetName === item.name) {
            item.linkForm = e.widget.linkForm;
          }
          return null;
        });
      } else {
        item = BsyUtils.getFieldAttr(item);
      }
    } else {
      if (item.type === "linkquery" || item.type === "linkdata") {
        items.map((e) => {
          if (e.widget.widgetName === item.name) {
            item.linkForm = e.widget.linkForm;
            item.linkFilter = e.widget.linkFilter;
            item.linkFields = e.widget.linkFields;
            item.refAppId = e.widget.refAppId;
          }
          return null;
        });
      }
    }
    return item;
  };

  createItem = (item, selectTab) => {
    const { form, optAuth, ignoreOptAuth } = this.options;
    let that = this;
    item = this.widget2Item(item);
    if (!item || item.type == "dataload") {
      return "";
    }
    if (!item || item.type == "menu") {
      return "";
    }

    if (!ignoreOptAuth && item.name !== "label") {
      // if (optAuth) {

      //     if (optAuth.hasOwnProperty(item.name)) {
      //         if (!optAuth[item.name].visible) {
      //             return '';
      //         }
      //         item.visible = optAuth[item.name].visible
      //     }
      // }

      if (this.showRules && this.showRules.hasOwnProperty(item.name)) {
        if (this.showRules[item.name] === false) {
          return "";
        }
      }
    }

    if (this.labelHidden) item.labelHidden = this.labelHidden[item.name];
    if (this.linewidth) item.lineWidth = this.linewidth[item.name];

    var labelWidth = "";
    var textAlign = "";
    var layout = "";
    let col = 12;
    if (form) {
      if (item.name === "label" && item.type === "textarea") {
        form.pcLayout &&
          form.pcLayout.label &&
          form.pcLayout.label.layout === "horizontal" &&
          BsyUtils.isSupportHorizontalLayout(item.type) &&
          (layout = " layout-horizontal ");
        form.pcLayout &&
          form.pcLayout.label &&
          form.pcLayout.label.layout === "horizontal" &&
          BsyUtils.isSupportHorizontalLayout(item.type) &&
          (labelWidth = form.pcLayout.label.width);
        form.pcLayout &&
          form.pcLayout.label &&
          form.pcLayout.label.layout === "horizontal" &&
          BsyUtils.isSupportHorizontalLayout(item.type) &&
          form.pcLayout.label &&
          form.pcLayout.label.textAlign === "right" &&
          (textAlign = "textAlign-right");
        col = 12;
      } else {
        if (item.type === "subform") {
          col = 12;
        } else {
          if (item.lineWidth) {
            col = item.lineWidth;
          } else {
            if (form.layout) {
              if (form.layout.indexOf("-") != -1) {
                col = form.layout.split("-")[1];
              }
            }
          }
        }

        if (form.pcLayout) {
          // form.pcLayout.description && !form.pcLayout.description.visible && f.addClass('no-description');
          // form.pcLayout.input && form.pcLayout.input.width === "auto" && (form.formLayout !== "normal" && form.formLayout !== "grid-1") && (autoWidth = 'auto-width');
          form.pcLayout.label &&
            form.pcLayout.label.layout === "horizontal" &&
            BsyUtils.isSupportHorizontalLayout(item.type) &&
            (layout = " layout-horizontal ");
          form.pcLayout.label &&
            form.pcLayout.label.layout === "horizontal" &&
            BsyUtils.isSupportHorizontalLayout(item.type) &&
            form.pcLayout.label &&
            form.pcLayout.label.textAlign === "right" &&
            (textAlign = "textAlign-right");
          form.pcLayout.label &&
            form.pcLayout.label.layout === "horizontal" &&
            BsyUtils.isSupportHorizontalLayout(item.type) &&
            (labelWidth = form.pcLayout.label.width);
        }
      }
    }

    if (item.type === "button") {
      return "";
      // if (!enableRowEdit) {
      //     return '';
      // }

      // se.eventAlert = xxe.widget.eventAlert;
      // se.alertinfo = xxe.widget.alertinfo;
      // se.background = xxe.widget.background;

      // return <li className={"widget-data-view  x-grid-col-" + col + ' ' + layout}
      // >
      //     <div className="widget-label">
      //         <span className="label-title">{!item.labelHidden ? item.text ? item.text : item.title ? item.title : '' : ''}</span>
      //     </div>
      //     <div className={"widget-data " + item.type} >
      //         <BsyButton
      //             mode={window.mode}
      //             eventAlert={item.eventAlert}
      //             alertinfo={item.alertinfo}
      //             background={item.background}
      //             style={item.style}
      //             width={350}
      //             type={"blue"}
      //             text={item.btnText || item.text || item.title}
      //             click={(e) => {
      //                 e.stopPropagation()

      //                 // if (!enableRowEdit) {
      //                 //     return
      //                 // }

      //                 that.buttonEvent(item.name, -1, e);

      //             }}
      //         >
      //         </BsyButton>

      //     </div>
      // </li>
    }

    if (item.type === "chargers") {
      return (
        <>
          <li
            key={item.name + "current-node"}
            className={"widget-data-view  x-grid-col-" + col + " " + layout}
          >
            <div className="widget-label">
              <span className="label-title">
                {React.language("flow.node.current")}
              </span>
            </div>
            <div className={"widget-data " + item.type}>
              {this.formatData(item, null, "current-node")}
            </div>
          </li>
          <li
            key={item.name + "current-user"}
            className={"widget-data-view  x-grid-col-" + col + " " + layout}
          >
            <div className="widget-label">
              <span className="label-title">
                {React.language("flow.charger.current")}
              </span>
            </div>
            <div className={"widget-data " + item.type}>
              {this.formatData(item, null, "current-user")}
            </div>
          </li>
        </>
      );
    }

    if (["dataload"].includes(item.type)) {
      return "";
    }

    item.visible = true;
    if (form && item.type === "separator") {
      col = 12;
      item = {
        ...form.items.find((it) => {
          return item.name === it.widget.widgetName;
        }).widget,
        ...item,
      };
    }

    let val = this.formatData(item);
    const title = !item.labelHidden
      ? item.text
        ? item.text
        : item.title
          ? item.title
          : ""
      : "";
    let tabStyle = item.tab
      ? selectTab === item.tab
        ? item.tab
        : item.tab + " hide"
      : "";
    return (
      <li
        key={item.name}
        className={
          "widget-data-view  x-grid-col-" + col + " " + layout + tabStyle
        }
      >
        <div
          className="widget-label"
          style={{
            width: labelWidth,
            display: item.labelHidden
              ? "none"
              : item.type === "separator" &&
                ["style1", "style3", "style4", "style5"].includes(
                  item.lineStyle
                )
                ? "none"
                : "",
          }}
        >
          <span
            className="label-title"
            style={{ color: item.type === "separator" ? item.labelColor : "" }}
            dangerouslySetInnerHTML={{
              __html: item.type === "separator" ? item.labelStyle : title,
            }}
          ></span>
        </div>
        <div
          className={
            "widget-data " +
            (val && item.name != "label" ? " has-value " : "") +
            item.type
          }
          style={
            item.name === "label"
              ? {
                backgroundColor: "transparent",
                display: "flex",
                alignItems: "center",
              }
              : {}
          }
        >
          {val}
        </div>
      </li>
    );
  };

  wrapper = () => {
    const { showFields, multiTabs, hasMultiTab, tabItems } = this.options;
    let that = this;
    return (
      <>
        <ul>
          {showFields.map((e) => {
            if (!e) {
              return "";
            }
            if (this._isSystemField(e)) {
              return "";
            }

            if (e.tab) {
              return "";
            }
            return this.createItem(e);
          })}
        </ul>
        {hasMultiTab ? (
          <BsyFormMultiTab
            form={this}
            ref={this.multiTab}
            showRules={this.showRules}
            items={tabItems}
            theme={
              this.options.formTabsStyle
                ? this.options.formTabsStyle.theme
                : "drop-down-type-one"
            }
            themeColor={
              this.options.formTabsStyle
                ? this.options.formTabsStyle.themeColor
                : "#0265FF"
            }
            tabs={BsyUtils.getNoEmptyTabs(tabItems, multiTabs)}
            onCreateTabItem={(t, selectTab) => {
              return that.createItem(t, selectTab);
            }}
            onTabClick={(t) => { }}
          ></BsyFormMultiTab>
        ) : (
          ""
        )}
      </>
    );
  };

  systemWrapper = () => {
    const { showFields } = this.options;
    return (
      <ul className="systemField">
        {showFields.map((e) => {
          if (!e) {
            return "";
          }
          if (!this._isSystemField(e)) {
            return "";
          }

          if (e.tab) {
            return "";
          }
          return this.createItem(e);
        })}
      </ul>
    );
  };

  getSideKey = () => {
    const { appId, entryId, authGroupId, formId } = this.options;
    return BsyUtils.Store.getKey("datafullside", {
      appId: appId,
      entryId: formId || entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  getSideStatus = () => {
    return BsyUtils.Store.get(this.getSideKey()) || "false";
  };

  setSideStatus = (val) => {
    return BsyUtils.Store.set(this.getSideKey(), val);
  };

  getfullscreenKey = () => {
    const { appId, entryId, authGroupId, formId } = this.options;
    return BsyUtils.Store.getKey("datafullscreen", {
      appId: appId,
      entryId: formId || entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  getfullscreenStatus = () => {
    return BsyUtils.Store.get(this.getfullscreenKey()) || "false";
  };

  setfullscreenStatus = (val) => {
    return BsyUtils.Store.set(this.getfullscreenKey(), val);
  };

  closeFlow = (layerRef) => {
    let _opt = this.options;
    let that = this;
    BsyAlert({
      title: React.language("flow.close"),
      msg: React.language("flow.close.tip"),
      type: "warning",
      text4Ok: React.language("ok"),
      OkType: "blue",
      text4Cancel: React.language("cancel"),
      ok: () => {
        const { appId, entryId, formId, authGroupId } = _opt;
        let n = {
          appId: appId,
          entryId: entryId,
          formId: formId || entryId,
          dataId: _opt.data._id,
          authGroupId: authGroupId,
          popupFormPath: [],
          extDashData: _opt.extDashData,
        };

        let layerRef1 = null;
        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            layerRef1 = ref;
            return (
              <div>
                <BsySLoading />{" "}
              </div>
            );
          },
        });

        React.axios("/data/close_flow", n).then((res) => {
          layerRef1 && layerRef1.close();
          layerRef && layerRef.close();
          BsyUtils.applyFunc(that, _opt.onClose, [true, true], !1);
        });
      },
    });
  };

  getExtDashData = () => {
    var b = this,
      c = this.options;
    return c.widgetId && !c.rawdata ? c.extDashData : undefined;
  };

  submitHandler = (type, el) => {
    const { flowType, flowId, flow } = this.options;
    const _opt = this.options;
    const that = this;
    switch (type) {
      case "print": {
        this._createPrintfList(el, () => {
          this._doPrint();
        });
        break;
      }
      case "urge": {
        var urgeNodes = flow.urgeNodes;

        if (urgeNodes.length == 1) {
          submit([urgeNodes[0].flowId]);
        } else {
          var menu = [];
          var allNode = [];
          menu.push({
            text: React.language("flow.Urge.process.all"),
            colorType: "",
            click: () => {
              submit(allNode);
            },
          });
          BsyUtils.forEach(urgeNodes, function (a1, b1) {
            allNode.push(b1.flowId);
            menu.push({
              text: b1.name,
              colorType: "",

              click: () => {
                submit([b1.flowId]);
              },
            });
          });
          BsyAlertMenu({
            item: menu,
            width: 220,
            target: el.target,
            onClose: () => { },
          });
        }

        function add_flow_urge(flowTarget) {
          React.axios("/data/add_flow_urge", {
            appId: _opt.appId,
            entryId: _opt.entryId,
            formId: _opt.formId || _opt.entryId,
            dataId: _opt.flow.dataId,
            flowIds: flowTarget,
            extDashData: that.getExtDashData(),
          }).then((res) => { });
          // FX.Utils.dataAjax({
          //     url: "/data/add_flow_urge",
          //     data: {
          //         appId: _opt.appId,
          //         entryId: _opt.entryId,
          //         formId: _opt.formId || _opt.entryId,
          //         dataId: _opt.flow.dataId,
          //         flowIds: flowTarget,
          //         extDashData: that.getExtDashData(),
          //     }
          // }, function (a) {
          //     // alert("add_flow_urge "+JSON.stringify(flowTarget))
          // })
        }

        function submit(flowTarget) {
          React.axios("/data/flow_urge", {
            appId: _opt.appId,
            entryId: _opt.entryId,
            formId: _opt.formId || _opt.entryId,
            dataId: _opt.flow.dataId,
            flowTarget: flowTarget,
            isDing: window.dd ? !0 : !1,
            extDashData: that.getExtDashData(),
          }).then((res) => {
            var a = res.data;
            if (!BsyUtils.isObjectEmpty(a)) {
              if (
                !BsyUtils.isObjectEmpty(a.corpId) &&
                !BsyUtils.isObjectEmpty(a.users)
              ) {
                var routUrl = window.root_directroy
                  ? window.root_directroy + "/"
                  : "";
                BsyUtils._dingCreate({
                  users: a.users,
                  corpId: a.corpId,
                  type: 2, //1：图片 2：链接
                  alertType: 2, //0：电话 1：短信 2：应用内
                  // alertDate: {"format": "yyyy-MM-dd HH:mm", "value": "2020-02-29 14:00"},
                  text: a.creator + "提醒您审批他的流程." + _opt.formName,
                  bizType: 0, //0：通知DING 1：任务 2：会议
                  attachment: {
                    title: "待办任务通知", //附件的标题
                    url: a.url, //附件点击后跳转url
                    image:
                      window._bby_config.site +
                      routUrl +
                      "template/formreport/static/css/resources/images/dingMsgImage.png", //附件显示时的图片 【可选】
                    text: a.creator + "提交的催办需要你的审批，请点击查看", //附件显示时的消息体 【可选】
                    // showInApp: false, // 跳转url在PC客户端上的打开方式，true：从PC容器内打开，false：跳转到浏览器打开 【可选】
                  },
                  onSuccess: function (res) {
                    // 调用成功时回调
                    // alert("onSuccess")
                    add_flow_urge(flowTarget);
                    BsyUtils.applyFunc(that, _opt.onClose, [], !1);
                  },
                  onFail: function (err) {
                    // 调用失败时回调
                    console.log(err);
                  },
                });
              }
            } else BsyUtils.applyFunc(that, _opt.onClose, [], !1);
          });
        }

        break;
      }
      case "revoke": {
        // this.flowAction = 'revoke';
        React.axios("/data/update", {
          appId: _opt.appId,
          entryId: _opt.entryId,
          formId: _opt.formId || _opt.entryId,
          dataId: _opt.flow.dataId,
          flowId: flowId,
          flowType: flowType,
          flowAction: "revoke",
        })
          .then((res) => {
            BsyUtils.applyFunc(that, _opt.onClose, ["revoke"], !1);
          })
          .catch((err) => {
            BsyUtils.applyFunc(that, _opt.onClose, ["revoke"], !1);
          });
        break;
      }
      default: {
      }
    }
  };

  renderBtns = () => {
    const {
      submitText,
      printText,
      hasFlowPrint,
      flows,
      cancelText,
      flow,
      flowType,
      flowId,
    } = this.options;
    let that = this;
    let text = submitText;

    if (flow) {
      return (
        <>
          {this.btns.map((event, index) => {
            return (
              <BsyIconBtn
                text={event.text}
                type={event.type}
                click={(e) => {
                  this.submitHandler(event.handler, e);
                }}
                mode={window.mode}
              ></BsyIconBtn>
            );
          })}
          {this.moreBtns.length ? (
            <BsyIconBtn
              text={React.language("more")}
              type={"white"}
              click={(e) => {
                let menu = [];
                this.moreBtns.map((event) => {
                  menu.push({
                    text: event.text,
                    click: (e) => {
                      this.submitHandler(event.handler, e);
                    },
                  });
                });
                BsyAlertMenu({
                  item: menu,
                  width: 100,
                  target: e.target,
                });
              }}
              mode={window.mode}
            ></BsyIconBtn>
          ) : (
            ""
          )}
        </>
      );
    }
  };

  openRawdata = () => {
    let that = this;
    let _opt = this.options;
    let config = {
      appId: _opt.appId,
      entryId: _opt.entryId,
      formId: _opt.formId || _opt.entryId,
      needFetchViewData: true,
      refAppId: _opt.refAppId,
      dataUrl: "/data/dash_process_data",
      data: {},
      originPrint: _opt.originPrint,
      title: _opt.title,
      formName: _opt.formName,
      rawdata: false,
      // ignoreVisible: true,
      hasSwitchBtn: false,
      hasShareBtn: true,
      width: _opt.width,
      dataId: _opt.data._id,
      extDashData: _opt.extDashData, //
      popupFormPath: _opt.popupFormPath,
      comments: null,
      forms: _opt.forms,
      onCloseFlow: function () {
        that.closeFlow(layerRef);
      },

      onDeleteData: function () {
        BsyUtils.applyFunc(that, _opt.onDeleteData, [], !1);
        layerRef && layerRef.close();
      },
    };

    let layerRef = null;
    BsyMaskLayer({
      customCls: "fadein-right",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("BsyMaskLayer")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;

        return (
          <BsyFormPane
            {...config}
            entrance={"form"}
            mode={"view"}
            onClose={(status, data) => {
              layerRef && layerRef.close();
              if (status && data) {
                this.props.onRefresh?.(data);
              }
            }}
          />
        );
      },
    });
  };

  renderFooter = () => {
    const {
      hasComment,
      hasLog,
      hasFlowLog,
      ignoreOptAuth,
      formTheme,
      buttonPosition,
      mode,
    } = this.options;
    let haslog =
      hasLog || hasComment || hasFlowLog || ignoreOptAuth ? true : false;

    if (mode === "print") {
      return (
        <>
          {
            <div className={"bsy-footer " + (haslog ? "hasLog " : " ")}>
              <div className={"btn-pane " + buttonPosition}>
                <BsyIconBtn
                  text={React.language("print")}
                  type={"blue"}
                  click={(e) => {
                    this._createPrintfList(e, () => {
                      this._doPrint();
                    });
                  }}
                  mode={window.mode}
                ></BsyIconBtn>
              </div>
            </div>
          }
        </>
      );
    }

    return (
      <>
        {BsyUtils.isObjectEmpty(formTheme) && mode !== "view" && (
          <div className={"bsy-footer " + (haslog ? "hasLog " : " ")}>
            <div className={"btn-pane " + buttonPosition}>
              {this.renderBtns()}
            </div>
          </div>
        )}
      </>
    );
  };

  renderFormLogPane() {
    const {
      extDashData,
      hasComment,
      hasLog,
      hasFlowLog,
      forms,
      formId,
      data,
      authGroupId,
      flowType,
      flowId,
      popupFormPath,
      ignoreOptAuth,
      dataUrl,
      flow,
      refAppId,
      appId,
      entryId,
    } = this.options;
    const options = {
      hasComment,
      hasLog,
      hasFlowLog,
      status: this.status,
      dataId: data._id,
      data: { ...data },
      fields: this.showFields || this.header || this.allShowFields,
      authGroupId: authGroupId,
      flowType: flowType,
      flowId: flowId,
      flow: flow,
      popupFormPath: popupFormPath,
      ignoreOptAuth: ignoreOptAuth,
      refAppId: refAppId,
      logs: this.state.comments,
      extDashData: this.extDashData(),
      formId: formId || (BsyUtils.isArray(forms) ? forms[0] : forms),
      appId: appId,
      entryId: entryId,
      onExpand: (status) => {
        this.setSideStatus(status);
        if (status == "false") {
          this.element.current.classList.remove("side");
        } else {
          this.element.current.classList.add("side");
        }
      },
    };

    if (dataUrl === "/data/dash_process_data") {
      options.popupFormPath = null;
    }
    if (
      !this.state.error &&
      (hasLog || hasComment || hasFlowLog || ignoreOptAuth)
    ) {
      return <BsyFormLogPane {...options} />;
    }
    return "";
  }

  render() {
    const {
      cssName,
      css,
      hasHeader,
      hasComment,
      hasLog,
      hasFlowLog,
      hasPrintBtn,
      hasRecoverBtn,
      hasShowFieldsBtn,
      rawdata,
    } = this.options;
    css.width = "100%";

    return (
      <div className={cssName} style={css} ref={this.element}>
        {hasHeader ? this.renderHeader() : ""}

        <div className={"form-data-container"}>
          {
            <div
              className={
                "widget-wrapper " +
                (hasComment || hasLog || hasFlowLog ? "hasLog" : "")
              }
            >
              {this.state.loading ? (
                <BsySLoading></BsySLoading>
              ) : (
                <>
                  {this._isEditable() ||
                    hasPrintBtn ||
                    hasRecoverBtn ||
                    hasShowFieldsBtn
                    ? this.renderMeunPane()
                    : ""}
                  {!this.state.error ? (
                    <div className="data-wrapper">
                      {this.wrapper()}
                      {this.systemWrapper()}
                      {this.createFlowCommentsPane()}
                      {this.state.showtip ? (
                        this.state.showtip == "next" ? (
                          <div
                            className="bsy-switch-tip"
                            style={{ zIndex: window.FX.STATIC.zIndex++ }}
                          >
                            <span>
                              {React.language(
                                "data.view." + this.state.showtip
                              )}
                            </span>
                            <i
                              className={
                                this.state.showtip + " icon-angleright"
                              }
                            ></i>
                          </div>
                        ) : (
                          <div
                            className="bsy-switch-tip"
                            style={{ zIndex: window.FX.STATIC.zIndex++ }}
                          >
                            <i
                              className={this.state.showtip + " icon-angleleft"}
                            ></i>
                            <span>
                              {React.language(
                                "data.view." + this.state.showtip
                              )}
                            </span>
                          </div>
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
              {rawdata ? (
                <div className="view-rawdata " onClick={this.openRawdata}>
                  <div className="dfe">{React.language("view.raw.data")}</div>
                </div>
              ) : (
                ""
              )}
              {this.renderFooter()}
            </div>
          }
          {this.renderFormLogPane()}
        </div>
      </div>
    );
  }
}

export default BsyFormData;
